var T = function (k, f) { var d = typeof window !== 'undefined' && window.VP_I18N; return d && typeof d[k] === 'string' ? d[k] : f; }; // vp-i18n T()
/* 欧洲改造 leftovers/misc（裁决 65）：首页积木搭建器等处 JS 改写的金额。window.VP_MONEY（snippets/vp-i18n-js，只在 vp_intl 为真时输出：
   非主语言或非店铺币种）存在时，按它的 Liquid money 样本（1234.56 的格式化结果）解析 raw 里的金额、加 delta、再按同一写法格式化，
   只替换 raw 里第一个到最后一个数字那一段（「Ab」「À partir de」、币种符号和位置都保留）；认不出格式就原样返回 raw。
   美国 / JP 没有 VP_MONEY：返回 null，调用方走原来的 "$" 写法，行为和字节都不变。 */
var vpFxPrice = function (raw, delta) {
  var M = typeof window !== 'undefined' && window.VP_MONEY;
  if (!M) return null;
  var s = String(M.f || ''), a = s.search(/[0-9]/), b = s.length;
  while (b > 0 && !/[0-9]/.test(s.charAt(b - 1))) b--;
  var m = a < 0 ? null : s.slice(a, b).match(/^1([^0-9]?)23(?:4([^0-9])56|5)$/);
  var r = String(raw == null ? '' : raw), i = r.search(/[0-9]/), j = r.length;
  while (j > 0 && !/[0-9]/.test(r.charAt(j - 1))) j--;
  if (!m || i < 0) return r;
  var t = r.slice(i, j);
  if (m[1]) t = t.split(m[1]).join('');
  if (m[2]) t = t.split(m[2]).join('.');
  var cents = Math.round((parseFloat(t) + (Number(delta) || 0)) * 100);
  if (!isFinite(cents)) return r;
  var n = Math.abs(cents), whole, frac = '';
  if (m[2]) { whole = Math.floor(n / 100); if (n % 100) frac = m[2] + (n % 100 < 10 ? '0' : '') + (n % 100); }
  else whole = Math.round(n / 100);
  return r.slice(0, i) + (cents < 0 ? '-' : '') + String(whole).replace(/\B(?=([0-9]{3})+(?![0-9]))/g, m[1] || '') + frac + r.slice(j);
};
/* ALL0929 促销：首页积木搭建器的划线价 = 现价文字里的金额 × 2（全站 compareAtPrice = price × 2）；有 VP_MONEY（非美元 / 非英文）时按它的格式写，否则写 $；认不出金额返回空串（调用方就把划线收起来）。 */ var vpWasText = function (shown) { var r = String(shown == null ? '' : shown), i = r.search(/[0-9]/), j = r.length; while (j > 0 && !/[0-9]/.test(r.charAt(j - 1))) j--; if (i < 0) return ''; var M = typeof window !== 'undefined' && window.VP_MONEY, t = r.slice(i, j), n; if (M) { var s = String(M.f || ''), a = s.search(/[0-9]/), b = s.length; while (b > 0 && !/[0-9]/.test(s.charAt(b - 1))) b--; var m = a < 0 ? null : s.slice(a, b).match(/^1([^0-9]?)23(?:4([^0-9])56|5)$/); if (!m) return ''; var num = function (x) { if (m[1]) x = x.split(m[1]).join(''); if (m[2]) x = x.split(m[2]).join('.'); return parseFloat(x); }; n = num(t); var base = num(s.slice(a, b)); if (!isFinite(n) || !isFinite(base)) return ''; var out = vpFxPrice(s, n * 2 - base); return out === s ? '' : out; } n = parseFloat(t.replace(/,/g, '')); if (!isFinite(n)) return ''; var d = Math.round(n * 200) / 100; return '$' + (d % 1 === 0 ? String(d) : d.toFixed(2)).replace(/\B(?=([0-9]{3})+(?![0-9]))/g, ','); }; /* VoxelPals dual-world storefront — shared navigation and collection selection */
(function () {
  "use strict";

  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  var coarseQuery = window.matchMedia("(max-width: 720px), (pointer: coarse)");
  root.classList.add("motion-ready");
  root.classList.toggle("motion-reduced", motionQuery.matches);
  root.classList.toggle("motion-coarse", coarseQuery.matches);
  window.setTimeout(function () {
    if (!doc.querySelector("[data-reveal].is-revealed")) root.classList.remove("motion-ready");
  }, 2600);
  var HANDOFF_KEY = "vp-portal-handoff";
  var GATEWAY_CHOICE_KEY = "vp-world-choice-v1";
  var GATEWAY_OPEN_MS = 280;
  var FRAME_COUNT = 24;
  var COMMIT_FRAME = 12;
  var FRAME_MS_DESKTOP = 42;
  var FRAME_MS_MOBILE = 38;
  var PAGE_ANGLES = [0, 2, 5, 9, 14, 20, 28, 37, 47, 58, 68, 76, 82, 86, 88, 89.2, 90.8, 96, 105, 118, 133, 149, 165, 179.2];
  var PAGE_MASK = [0, 0, 0, 0, .01, .02, .04, .07, .10, .14, .20, .28, .38, .52, .72, 1, 1, .80, .56, .35, .19, .08, .02, 0];

  function routeWorld() {
    var path = window.location.pathname.toLowerCase();
    // 2026-09-20：bobbleheads / sculpted-figures 是新建的 3D 集合，theme.liquid 里也有一份同样的判断
    // 2026-09-21：主题集合统一以 -figurines 结尾，用后缀匹配，别再逐个枚举
    if (/\/collections\/(?:3d-line|bobbleheads|sculpted-figures|base-designs|occasion-themes)(?:\/|$)/.test(path) || /\/products\/3d-/.test(path) || /product-3d-/.test(path)) return "3d";
    // 2026-09-24：积木 Shop 页和积木主题合集 brick-occasions 也锁积木（theme.liquid 同步）
    if (/\/collections\/(?:brick-line|brick-occasions)(?:\/|$)/.test(path) || /\/pages\/products(?:\/|$)/.test(path) || /\/products\/(mini-you|the-duo|best-friend|the-crew)(?:\/|$)/.test(path) || /product-(mini-you|the-duo|grandparents|best-friends)/.test(path)) return "brick";
    return "";
  }

  function queryWorld() {
    try {
      var selected = new URL(window.location.href).searchParams.get("world");
      return selected === "brick" || selected === "3d" ? selected : "";
    } catch (_) { return ""; }
  }

  function storedWorld() {
    var selected = "";
    try {
      selected = localStorage.getItem("vp-world") || "";
      if (selected !== "brick" && selected !== "3d") selected = localStorage.getItem("vp-pixel") === "1" ? "brick" : "3d";
    } catch (_) { selected = "3d"; }
    return selected;
  }

  // 只认用户真实存过的世界，没存过返回空——与 storedWorld() 的"兜底猜 3d"区分开。
  // 用在启动链里：共享页（cart/search/blog…）的 data-world="brick" 是服务端默认值
  // 不是路由信号，必须排在它前面，否则 3D 访客进购物车会被拽回积木世界，
  // 且 rememberWorld 会顺手把他的 3D 偏好覆写掉（2026-08-11 线上实测的故障）。
  function storedWorldExplicit() {
    try {
      var selected = localStorage.getItem("vp-world");
      return selected === "brick" || selected === "3d" ? selected : "";
    } catch (_) { return ""; }
  }

  function resolveWorld() {
    // 2026-10-20 积木线暂停（主题设置「积木线」）：html 上有 data-brick-off 时一律 3D
    if (root.hasAttribute("data-brick-off")) return "3d";
    // Startup and bfcache share one order: route lock > URL > saved preference.
    // Explicit route metadata also covers product paths absent from routeWorld().
    var locked = body.getAttribute("data-route-world");
    if (locked === "brick" || locked === "3d") return locked;
    return routeWorld() || queryWorld() || storedWorldExplicit() || root.getAttribute("data-world") || body.getAttribute("data-world") || storedWorld();
  }

  function resolveWorldFragment(world) {
    var url = new URL(window.location.href);
    var page = url.pathname.toLowerCase().match(/\/(how-it-works|about|faq)\.html$|\/pages\/(how-it-works|about|faq)\/?$/);
    if (!page || !url.hash) return null;
    var id = "";
    try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) {}
    var target = id ? doc.getElementById(id) : null;
    function owner(node) {
      for (; node; node = node.parentElement) {
        var value = node.getAttribute("data-world-panel") || node.getAttribute("data-world-only");
        if (value === "brick" || value === "3d") return value;
      }
      return "";
    }
    function belongsToWorld(node) {
      for (; node; node = node.parentElement) {
        var panel = node.getAttribute("data-world-panel");
        var only = node.getAttribute("data-world-only");
        if ((panel === "brick" || panel === "3d") && panel !== world) return false;
        if ((only === "brick" || only === "3d") && only !== world) return false;
      }
      return true;
    }
    // Shared anchors (including FAQ categories hidden by a search) do not
    // become invalid just because their current layout is temporarily hidden.
    if (target && belongsToWorld(target)) return null;
    // These are semantic pairs, not an ID-suffix substitution: How has three
    // Brick chapters but four 3D chapters, so its later steps are not paired.
    var pairs = (page[1] || page[2]) === "how-it-works" ? [
      ["chapter-brick-01", "commission-step-3d-01"],
      ["chapter-brick-02", "commission-step-3d-02"]
    ] : (page[1] || page[2]) === "about" ? [["values", "values-3d"]] : [];
    var destination = world === "brick" ? 0 : 1;
    var counterpart = null;
    pairs.some(function (pair) {
      if (!target || id !== pair[1 - destination] || owner(target) === world) return false;
      var candidate = doc.getElementById(pair[destination]);
      if (!candidate || owner(candidate) !== world || !belongsToWorld(candidate) || candidate.closest("[hidden]")) return false;
      counterpart = candidate;
      return true;
    });
    if (counterpart) return { hash: "#" + counterpart.id, target: counterpart };
    // Unknown fragments and unpaired world-specific sections must not point
    // into the panel just hidden. Only use #top when it really is shared.
    var top = doc.getElementById("top");
    if (top && (owner(top) || top.closest("[hidden]"))) top = null;
    return { hash: top ? "#top" : "", target: top };
  }

  var state = {
    world: resolveWorld(),
    phase: "idle",
    runId: 0,
    queued: null,
    current: null,
    trigger: null,
    section: null,
    navigating: false
  };
  if (state.world !== "brick" && state.world !== "3d") state.world = "3d";

  var portal = doc.getElementById("portal");
  var gateway = doc.querySelector("[data-world-gateway]");
  var portalWash = portal ? portal.querySelector(".portal__wash") : null;
  var portalBook = portal ? portal.querySelector(".portal__book") : null;
  var portalTargetPage = portal ? portal.querySelector(".portal__page--target") : null;
  var portalLeaf = portal ? portal.querySelector(".portal__leaf") : null;
  var portalFrontFace = portal ? portal.querySelector(".portal__face--front") : null;
  var portalBackFace = portal ? portal.querySelector(".portal__face--back") : null;
  var portalTargetBrick = portal ? portal.querySelector(".portal__target--brick") : null;
  var portalTarget3d = portal ? portal.querySelector(".portal__target--3d") : null;
  var portalFrontBrick = portal ? portal.querySelector(".portal__front--brick") : null;
  var portalFront3d = portal ? portal.querySelector(".portal__front--3d") : null;
  var portalBackBrick = portal ? portal.querySelector(".portal__back--brick") : null;
  var portalBack3d = portal ? portal.querySelector(".portal__back--3d") : null;
  var portalFrontShade = portalFrontFace ? portalFrontFace.querySelector(".portal__shade") : null;
  var portalBackShade = portalBackFace ? portalBackFace.querySelector(".portal__shade") : null;
  var portalEdge = portal ? portal.querySelector(".portal__edge") : null;
  var portalFlash = portal ? portal.querySelector(".portal__flash") : null;
  var portalImages = [portalTargetBrick, portalTarget3d, portalFrontBrick, portalFront3d, portalBackBrick, portalBack3d];
  var portalMediaSources = {
    brick: portalTargetBrick ? (portalTargetBrick.getAttribute("data-portal-src") || portalTargetBrick.getAttribute("data-src") || portalTargetBrick.getAttribute("src") || portalTargetBrick.currentSrc || "") : "",
    "3d": portalTarget3d ? (portalTarget3d.getAttribute("data-portal-src") || portalTarget3d.getAttribute("data-src") || portalTarget3d.getAttribute("src") || portalTarget3d.currentSrc || "") : ""
  };
  var motionController = null;
  var portalMediaCache = {};
  var status = doc.getElementById("worldStatus");
  var main = doc.querySelector("main");
  var nav = doc.getElementById("nav");
  var foot = doc.querySelector(".foot");

  function worldName(world) { return world === "brick" ? T('js.app.world_brick', "Brick World") : T('js.app.world_3d', "3D World"); }
  function sameUrl(a, b) {
    try {
      var ua = new URL(a, window.location.href);
      var ub = new URL(b, window.location.href);
      return ua.origin === ub.origin && ua.pathname.replace(/\/$/, "") === ub.pathname.replace(/\/$/, "") && ua.search === ub.search && ua.hash === ub.hash;
    } catch (_) { return a === b; }
  }

  function announce(message) {
    if (!status) return;
    status.textContent = "";
    window.setTimeout(function () { status.textContent = message; }, 0);
  }

  function rememberWorld(world, manual) {
    if (root.hasAttribute("data-brick-off")) world = "3d";
    if (world !== "brick" && world !== "3d") return;
    // A route selects this page's presentation, not the visitor's preference.
    // Keep existing choices until a gateway/control explicitly replaces them.
    if (!manual && storedWorldExplicit()) return;
    try {
      localStorage.setItem("vp-world", world);
      localStorage.setItem("vp-pixel", world === "brick" ? "1" : "0");
      // 只有用户主动切换才算"记住的选择"；启动时的自动写入不算，
      // 否则老访客会被早期默认值永远困在 3D 世界
      if (manual) {
        localStorage.setItem("vp-world-src", "user");
        localStorage.setItem(GATEWAY_CHOICE_KEY, world);
      }
    } catch (_) {}
  }

  function clearPortalImage(image) {
    if (!image) return;
    image.removeAttribute("src");
    image.removeAttribute("srcset");
  }

  function releasePortalMedia() {
    portalImages.forEach(clearPortalImage);
  }

  function preloadPortalWorld(world, done) {
    var source = portalMediaSources[world];
    if (!source) { done(false); return; }
    if (portalMediaCache[world] === source) { done(true); return; }
    var image = new Image();
    var settled = false;
    var timer = window.setTimeout(function () { finish(false); }, 2400);
    function finish(ok) {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      image.onload = null;
      image.onerror = null;
      if (ok) portalMediaCache[world] = source;
      done(ok);
    }
    image.onload = function () { finish(image.naturalWidth > 0); };
    image.onerror = function () { finish(false); };
    image.decoding = "async";
    image.src = source;
    if (image.complete) finish(image.naturalWidth > 0);
  }

  function assignPortalImage(image, world) {
    if (!image || !portalMediaSources[world]) return;
    image.setAttribute("src", portalMediaSources[world]);
  }

  function preparePortalMedia(origin, destination, done) {
    var worlds = origin === destination ? [destination] : [origin, destination];
    var pending = worlds.length;
    var ready = true;
    worlds.forEach(function (world) {
      preloadPortalWorld(world, function (ok) {
        ready = ready && ok;
        pending -= 1;
        if (pending) return;
        if (ready) {
          releasePortalMedia();
          assignPortalImage(origin === "brick" ? portalFrontBrick : portalFront3d, origin);
          assignPortalImage(destination === "brick" ? portalBackBrick : portalBack3d, destination);
          assignPortalImage(destination === "brick" ? portalTargetBrick : portalTarget3d, destination);
        }
        done(ready);
      });
    });
  }

  function syncPanels(world) {
    [].forEach.call(doc.querySelectorAll("[data-world-panel]"), function (panel) {
      var active = panel.getAttribute("data-world-panel") === world;
      panel.hidden = !active;
      panel.setAttribute("aria-hidden", active ? "false" : "true");
      try { panel.inert = !active; } catch (_) {}
    });
  }

  function syncControls(world) {
    [].forEach.call(doc.querySelectorAll("[data-world-switch]"), function (control) {
      var active = control.getAttribute("data-world-switch") === world;
      control.classList.toggle("is-active", active);
      if (control.tagName === "BUTTON") control.setAttribute("aria-pressed", active ? "true" : "false");
      else control.removeAttribute("aria-pressed");
      if (active) control.setAttribute("aria-current", control.tagName === "A" ? "page" : "true");
      else control.removeAttribute("aria-current");
    });
    [].forEach.call(doc.querySelectorAll("[data-world-href-brick][data-world-href-3d]"), function (link) {
      var next = link.getAttribute("data-world-href-" + world);
      if (next) link.setAttribute("href", next);
    });
    [].forEach.call(doc.querySelectorAll("[data-world-value-brick][data-world-value-3d]"), function (field) {
      field.value = field.getAttribute("data-world-value-" + world) || "";
    });
  }

  function refreshReveals() {
    if (motionController && motionController.refreshReveals) {
      motionController.refreshReveals();
      return;
    }
    [].forEach.call(doc.querySelectorAll("[data-reveal]"), function (el) {
      if (el.hidden || el.closest("[hidden]")) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 1.05) el.classList.add("is-revealed");
    });
    if (window.ScrollTrigger && window.ScrollTrigger.refresh) window.ScrollTrigger.refresh(true);
  }

  function captureSection() {
    var best = null;
    [].forEach.call(doc.querySelectorAll("[data-section-key]"), function (section) {
      if (section.hidden || section.closest("[hidden]")) return;
      var rect = section.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      if (!best || Math.abs(rect.top) < Math.abs(best.top)) best = { key: section.getAttribute("data-section-key"), top: rect.top };
    });
    return best;
  }

  function restoreSection(snapshot) {
    if (!snapshot || !snapshot.key) return;
    window.setTimeout(function () {
      var target = null;
      [].some.call(doc.querySelectorAll('[data-section-key="' + snapshot.key + '"]'), function (item) {
        if (!item.hidden && !item.closest("[hidden]")) { target = item; return true; }
        return false;
      });
      if (!target) return;
      var delta = target.getBoundingClientRect().top - snapshot.top;
      if (Math.abs(delta) > 1) window.scrollBy(0, delta);
    }, 0);
  }

  function commitWorld(world, options) {
    options = options || {};
    if (world !== "brick" && world !== "3d") return;
    var previousWorld = state.world;
    var fragment = null;
    state.world = world;
    root.setAttribute("data-world", world);
    body.setAttribute("data-world", world);
    body.classList.remove("pixel-world");
    syncPanels(world);
    syncControls(world);
    if (options.persist !== false) rememberWorld(world, options.manual === true);
    if (options.updateUrl !== false && pageHasWorldContent() && window.history && window.history.replaceState) {
      try {
        var worldUrl = new URL(window.location.href);
        worldUrl.searchParams.set("world", world);
        if (previousWorld !== world) fragment = resolveWorldFragment(world);
        if (fragment) worldUrl.hash = fragment.hash;
        window.history.replaceState(window.history.state, "", worldUrl.pathname + worldUrl.search + worldUrl.hash);
      } catch (_) { fragment = null; }
    }
    if (options.restore !== false) {
      if (fragment) {
        window.setTimeout(function () {
          if (state.world !== world) return;
          if (fragment.target) fragment.target.scrollIntoView({ block: "start", behavior: "instant" });
          else window.scrollTo({ top: 0, behavior: "instant" });
        }, 0);
      } else restoreSection(state.section);
    }
    refreshReveals();
    window.dispatchEvent(new CustomEvent("vp:worldchange", { detail: { world: world } }));
  }

  function setInteractiveLock(locked) {
    root.classList.toggle("is-world-transitioning", locked);
    if (locked) body.setAttribute("aria-busy", "true");
    else body.removeAttribute("aria-busy");
    [nav, main, foot].forEach(function (region) { if (region) { try { region.inert = locked; } catch (_) {} } });
    [].forEach.call(doc.querySelectorAll("[data-world-switch]"), function (control) {
      if (locked) {
        control.setAttribute("aria-disabled", "true");
        if (control.tagName === "BUTTON") control.disabled = true;
      } else {
        control.removeAttribute("aria-disabled");
        if (control.tagName === "BUTTON") control.disabled = false;
      }
    });
  }

  function phaseForFrame(frame) {
    if (frame < 4) return "capture";
    if (frame < 9) return "lift";
    if (frame < 15) return "turn";
    if (frame < 17) return "carry";
    if (frame < 21) return "settle";
    return "reveal";
  }
  function easeOut(value) { return 1 - Math.pow(1 - value, 3); }
  function easeInOut(value) { return value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2; }

  function setWorldLayer(brick, three, world) {
    if (brick) brick.style.opacity = world === "brick" ? "1" : "0";
    if (three) three.style.opacity = world === "3d" ? "1" : "0";
  }

  function drawPortalFrame(frame, destination) {
    if (!portal) return;
    var progress = Math.max(0, Math.min(1, frame / (FRAME_COUNT - 1)));
    var opacity = progress < .42 ? easeInOut(progress / .42) : progress <= .60 ? 1 : 1 - easeInOut((progress - .60) / .40);
    portal.setAttribute("data-mode", "veil");
    portal.setAttribute("data-frame", String(Math.round(frame)).padStart(2, "0"));
    portal.setAttribute("data-phase", progress < .45 ? "arrive" : progress < .61 ? "carry" : "reveal");
    portal.setAttribute("data-target", destination);
    portal.style.opacity = opacity.toFixed(3);
    portal.style.setProperty("--veil-drift", ((progress - .5) * 18).toFixed(2) + "%");
    root.style.removeProperty("--world-page-scale");
  }

  function clearPortalVisuals() {
    if (!portal) return;
    portal.hidden = true;
    releasePortalMedia();
    portal.removeAttribute("data-frame"); portal.removeAttribute("data-phase"); portal.removeAttribute("data-target"); portal.removeAttribute("data-origin"); portal.removeAttribute("data-turn");
    portal.style.opacity = "";
    [portalTargetBrick, portalTarget3d, portalFrontBrick, portalFront3d, portalBackBrick, portalBack3d].forEach(function (image) {
      if (!image) return;
      image.style.opacity = "";
    });
    if (portalWash) portalWash.style.opacity = "";
    if (portalBook) { portalBook.style.transform = ""; portalBook.style.opacity = ""; }
    if (portalLeaf) { portalLeaf.style.transform = ""; portalLeaf.style.transformOrigin = ""; portalLeaf.style.opacity = ""; }
    [portalFrontFace, portalBackFace, portalTargetPage].forEach(function (page) {
      if (!page) return;
      page.style.opacity = "";
      page.style.visibility = "";
      page.style.borderRadius = "";
      page.style.backgroundColor = "";
    });
    if (portalFrontShade) portalFrontShade.style.opacity = "";
    if (portalBackShade) portalBackShade.style.opacity = "";
    if (portalEdge) portalEdge.style.opacity = "";
    if (portalFlash) portalFlash.style.opacity = "";
    root.style.removeProperty("--world-page-scale");
    root.classList.remove("portal-arrival-pending");
  }

  function focusAfterPortal() {
    var target = state.trigger;
    if (!target || !target.isConnected || target.closest("[hidden]") || target.closest("[inert]")) {
      target = doc.querySelector('[data-world-switch="' + state.world + '"]');
    }
    if (target && target.isConnected && !target.closest("[hidden]")) {
      try { target.focus({ preventScroll: true }); } catch (_) { try { target.focus(); } catch (__) {} }
    }
  }

  function endPortal() {
    clearPortalVisuals();
    state.phase = "idle";
    state.current = null;
    state.navigating = false;
    setInteractiveLock(false);
    window.dispatchEvent(new CustomEvent("vp:transitionend", { detail: { world: state.world } }));
    announce(T('js.app.announce_now_in', "Now in ") + worldName(state.world));
    focusAfterPortal();
    state.trigger = null;
    var next = state.queued;
    state.queued = null;
    if (next && (next.world !== state.world || next.href)) requestWorld(next);
  }

  function playFrames(start, end, destination, onFrame, onDone) {
    var id = state.runId;
    var began = null;
    var duration = 600 * (end - start) / (FRAME_COUNT - 1);
    var settled = false;
    var frameId = null;
    // Rendering can stall while the document remains interactive. Navigation
    // must finish even when RAF never starts or stops halfway through a turn.
    var watchdog = window.setTimeout(function () { deliver(end, true); }, Math.max(1000, duration + 400));
    function stop() {
      settled = true;
      window.clearTimeout(watchdog);
      if (frameId !== null) window.cancelAnimationFrame(frameId);
    }
    function deliver(frame, finalFrame) {
      if (settled) return false;
      if (id !== state.runId) { stop(); return false; }
      state.phase = phaseForFrame(Math.floor(frame));
      drawPortalFrame(frame, destination);
      var proceed = !onFrame || onFrame(frame) !== false;
      if (!proceed || id !== state.runId) { stop(); return false; }
      if (finalFrame) {
        stop();
        if (onDone) onDone();
        return false;
      }
      return true;
    }
    function step(now) {
      if (settled) return;
      if (id !== state.runId) { stop(); return; }
      if (began === null) began = now;
      var progress = Math.min(1, (now - began) / Math.max(duration, 1));
      if (deliver(start + (end - start) * progress, progress === 1)) frameId = window.requestAnimationFrame(step);
    }
    frameId = window.requestAnimationFrame(step);
  }

  function saveHandoff(href, world, origin) {
    try {
      sessionStorage.setItem(HANDOFF_KEY, JSON.stringify({ v: 1, mode: "veil", to: new URL(href, window.location.href).href, world: world, origin: origin, nextFrame: COMMIT_FRAME, ts: Date.now() }));
    } catch (_) {}
  }

  function beginNavigation(href, world, origin) {
    saveHandoff(href, world, origin);
    state.navigating = true;
    window.setTimeout(function () { window.location.assign(href); }, 16);
  }

  function runPortal(intent) {
    if (!portal) {
      if (intent.href) { rememberWorld(intent.world, true); window.location.assign(intent.href); }
      else commitWorld(intent.world);
      return;
    }
    state.runId += 1;
    intent.origin = state.world;
    state.current = intent;
    state.phase = "preparing";
    state.trigger = intent.trigger || null;
    state.section = captureSection();
    setInteractiveLock(true);
    window.dispatchEvent(new CustomEvent("vp:transitionstart", { detail: { from: intent.origin, world: intent.world } }));
    announce(T('js.app.announce_opening', "Opening ") + worldName(intent.world));
    portal.setAttribute("data-origin", intent.origin);
    portal.setAttribute("data-mode", "veil");
    portal.hidden = false;
    // No product artwork needs to download before this shared light curtain.
    var committed = false;
    playFrames(0, FRAME_COUNT - 1, intent.world, function (frame) {
      if (!committed && frame >= COMMIT_FRAME) {
        committed = true;
        if (intent.href) {
          rememberWorld(intent.world, true);
          beginNavigation(intent.href, intent.world, intent.origin);
          return false;
        }
        commitWorld(intent.world, { restore: true });
      }
      return true;
    }, function () {
      if (!committed) commitWorld(intent.world);
      endPortal();
    });
  }

  function requestWorld(intent) {
    if (!intent || (intent.world !== "brick" && intent.world !== "3d")) return;
    if (state.phase !== "idle") { state.queued = intent; return; }
    if (intent.world === state.world && !intent.href) return;
    if (motionQuery.matches) {
      state.section = captureSection();
      if (intent.href) {
        rememberWorld(intent.world, true);
        announce(T('js.app.announce_opening', "Opening ") + worldName(intent.world));
        window.location.assign(intent.href);
      } else {
        commitWorld(intent.world, { restore: true });
        announce(T('js.app.announce_now_in', "Now in ") + worldName(intent.world));
      }
      return;
    }
    runPortal(intent);
  }

  function pageHasWorldContent() {
    return !!doc.querySelector("main [data-world-panel], main [data-world-only]");
  }

  function isProductPage() {
    return /(?:^|\/)product(?:s)?[-\/]/.test(window.location.pathname.toLowerCase()) || !!doc.querySelector(".product-hero, .pdp, [data-product-world]");
  }

  function valueAsHref(node, name, destination) {
    if (!node || !node.hasAttribute || !node.hasAttribute(name)) return null;
    var value = (node.getAttribute(name) || "").trim();
    if (value && value !== "true" && value !== destination && value !== "brick" && value !== "3d") return value;
    if (node.tagName === "A") return node.href;
    return null;
  }

  function counterpartHref(destination, control) {
    // Native Shopify products expose their route on an article inside main;
    // static products expose it on body. Inspect both explicit owners before
    // legacy editorial links, so a product's related card cannot choose the
    // destination of the header switch.
    var productScope = doc.querySelector("[data-product-world]");
    var nodes = [control, productScope, body, main, root];
    var names = [
      "data-world-pair-" + destination,
      "data-world-counterpart-" + destination,
      "data-counterpart-" + destination,
      "data-world-href-" + destination
    ];
    var href = null;
    nodes.some(function (node) {
      return names.some(function (name) {
        href = valueAsHref(node, name, destination);
        return !!href;
      });
    });
    if (href) return href;

    var candidates = doc.querySelectorAll("[data-world-pair], [data-world-counterpart], [data-counterpart]");
    [].some.call(candidates, function (node) {
      var markedWorld = node.getAttribute("data-world") || node.getAttribute("data-world-switch");
      var pairValue = node.getAttribute("data-world-pair");
      var counterpartValue = node.getAttribute("data-world-counterpart") || node.getAttribute("data-counterpart");
      var sourceContainer = node === body || node === main || node === root || node.hasAttribute("data-product-world");
      if (sourceContainer) {
        // A container's world is the SOURCE. Its bare pair points to the OTHER
        // world. Treating body[data-world=brick] as a destination marker used
        // to discard every Brick PDP pair while the 3D inner section worked.
        var sourceWorld = node.getAttribute("data-product-world") || node.getAttribute("data-route-world") || body.getAttribute("data-route-world");
        if (sourceWorld && sourceWorld === destination) return false;
      } else if (markedWorld && markedWorld !== destination) return false;
      if ((pairValue === "brick" || pairValue === "3d") && pairValue !== destination) return false;
      if ((counterpartValue === "brick" || counterpartValue === "3d") && counterpartValue !== destination) return false;
      href = valueAsHref(node, "data-world-pair", destination) || valueAsHref(node, "data-world-counterpart", destination) || valueAsHref(node, "data-counterpart", destination);
      return !!href;
    });
    if (href) return href;
    var editorialPair = doc.querySelector(".product-hero__actions a.text-link[href], a[data-product-counterpart][href]");
    return editorialPair ? editorialPair.href : null;
  }

  function homeUrl() {
    var brand = doc.querySelector("a.brand[href]");
    try { return new URL(brand ? brand.getAttribute("href") : "/", window.location.href); } catch (_) { return null; }
  }
  function samePath(a) { return a.replace(/\/index\.html$/, "").replace(/\/$/, ""); }
  function onHomePage() {
    var home = homeUrl();
    return home ? samePath(home.pathname) === samePath(window.location.pathname) : window.location.pathname === "/";
  }
  function worldHomeHref(world) {
    var home = homeUrl();
    if (!home) return "/?world=" + world + "#top";
    home.search = "?world=" + world;
    home.hash = "top";
    return home.href;
  }

  [].forEach.call(doc.querySelectorAll("[data-world-switch]"), function (control) {
    if (control.tagName !== "A" && control.tagName !== "BUTTON") {
      control.setAttribute("role", "button");
      if (!control.hasAttribute("tabindex")) control.setAttribute("tabindex", "0");
      control.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") { event.preventDefault(); control.click(); }
      });
    }
    control.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "Home" && event.key !== "End") return;
      var group = control.closest ? control.closest(".world-tabs") : null;
      if (!group) return;
      var controls = [].slice.call(group.querySelectorAll("[data-world-switch]:not([aria-disabled='true'])"));
      if (controls.length < 2) return;
      var index = controls.indexOf(control);
      if (event.key === "Home") index = 0;
      else if (event.key === "End") index = controls.length - 1;
      else index = (index + (event.key === "ArrowRight" ? 1 : -1) + controls.length) % controls.length;
      event.preventDefault();
      controls[index].focus();
    });
    control.addEventListener("click", function (event) {
      if (control.tagName === "A" && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      if (control.getAttribute("aria-disabled") === "true") { event.preventDefault(); return; }
      var destination = control.getAttribute("data-world-switch");
      if (destination !== "brick" && destination !== "3d") return;
      event.preventDefault();
      // Remember an explicit choice for shared pages. Unqualified home visits
      // always show the gateway; only a world URL opens the chosen homepage.
      rememberWorld(destination, true);
      // 2026-09-24 用户定：切换按钮一律去对应世界的首页，只有已经在首页才原地换
      // （首页两个世界的内容都在）。以前「共享页原地换 / 商品页跳对面商品」撤掉了 ——
      // 原地换在 Shop 这种只有积木商品的页面上会变成「3D 皮肤 + 积木商品」。
      var href = null;
      if (!onHomePage()) href = control.tagName === "A" ? control.href : worldHomeHref(destination);
      if (href && sameUrl(href, window.location.href)) href = null;
      requestWorld({ world: destination, href: href, trigger: control });
    });
  });

  function gatewayPending() {
    return !!gateway && root.getAttribute("data-entry") === "gateway";
  }

  function gatewayUrl(world) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("world", world);
      url.searchParams.delete("entry");
      url.hash = "top";
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return (window.location.pathname || "/") + "?world=" + world + "#top";
    }
  }

  function finishGateway(world) {
    if (!gateway) return;
    commitWorld(world, { restore: false, persist: false, updateUrl: false });
    try { window.history.replaceState(window.history.state, "", gatewayUrl(world)); } catch (_) {}
    gateway.setAttribute("data-gateway-state", "opened");
    root.setAttribute("data-entry", "world");
    body.removeAttribute("aria-busy");
    body.classList.remove("is-gateway-active");
    window.scrollTo(0, 0);
    window.setTimeout(function () {
      gateway.hidden = true;
      gateway.removeAttribute("style");
      gateway.removeAttribute("aria-busy");
      if (main) {
        main.setAttribute("tabindex", "-1");
        main.focus({ preventScroll: true });
      }
      if (motionController && motionController.refresh) motionController.refresh();
      window.dispatchEvent(new CustomEvent("vp:entryready", { detail: { world: world } }));
      announce(T('js.app.announce_now_in', "Now in ") + worldName(world));
    }, 40);
  }

  function openGateway(world, trigger) {
    if (!gateway || (world !== "brick" && world !== "3d")) return;
    var currentState = gateway.getAttribute("data-gateway-state");
    if (currentState === "opening" || currentState === "opened") return;
    rememberWorld(world, true);
    gateway.setAttribute("data-gateway-target", world);
    gateway.setAttribute("data-gateway-state", "opening");
    gateway.setAttribute("aria-busy", "true");
    body.setAttribute("aria-busy", "true");
    announce(T('js.app.announce_opening', "Opening ") + worldName(world));
    if (motionQuery.matches) {
      finishGateway(world);
      return;
    }
    window.setTimeout(function () { finishGateway(world); }, GATEWAY_OPEN_MS);
  }

  function initGateway() {
    if (!gateway) return;
    if (!gatewayPending()) {
      gateway.hidden = true;
      return;
    }
    body.classList.add("is-gateway-active");
    gateway.hidden = false;
    gateway.setAttribute("data-gateway-state", "loading");
    var lastChoice = storedWorldExplicit();
    try {
      var savedChoice = localStorage.getItem(GATEWAY_CHOICE_KEY);
      if (savedChoice === "brick" || savedChoice === "3d") lastChoice = savedChoice;
    } catch (_) {}
    [].forEach.call(gateway.querySelectorAll("[data-gateway-world]"), function (choice) {
      var remembered = choice.getAttribute("data-gateway-world") === lastChoice;
      choice.setAttribute("data-gateway-last-choice", remembered ? "true" : "false");
      if (remembered) choice.setAttribute("aria-description", T('js.app.gateway_last_choice', "Your last selected world"));
      choice.addEventListener("pointerenter", function () {
        if (gateway.getAttribute("data-gateway-state") !== "opening") gateway.setAttribute("data-gateway-target", choice.getAttribute("data-gateway-world") || "");
      });
      choice.addEventListener("pointerleave", function () {
        if (gateway.getAttribute("data-gateway-state") !== "opening") gateway.setAttribute("data-gateway-target", "");
      });
      choice.addEventListener("focus", function () {
        if (gateway.getAttribute("data-gateway-state") !== "opening") gateway.setAttribute("data-gateway-target", choice.getAttribute("data-gateway-world") || "");
      });
      choice.addEventListener("click", function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openGateway(choice.getAttribute("data-gateway-world"), choice);
      });
    });
    var gatewayImages = [].slice.call(gateway.querySelectorAll("img"));
    var decodeTasks = gatewayImages.map(function (image) {
      if (image.complete && image.naturalWidth > 0) {
        if (image.decode) return image.decode().catch(function () {});
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var settled = false;
        var timer = window.setTimeout(finish, 1800);
        function finish() {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          image.removeEventListener("load", finish);
          image.removeEventListener("error", finish);
          resolve();
        }
        image.addEventListener("load", finish);
        image.addEventListener("error", finish);
      });
    });
    Promise.all(decodeTasks).then(function () {
      if (!gateway || !gatewayPending() || gateway.getAttribute("data-gateway-state") !== "loading") return;
      gateway.setAttribute("data-gateway-state", "ready");
    });
  }

  [].forEach.call(doc.querySelectorAll("a[data-world-pair], a[data-world-counterpart], a[data-counterpart]"), function (link) {
    if (link.hasAttribute("data-world-switch")) return;
    link.addEventListener("click", function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var marker = link.getAttribute("data-world") || link.getAttribute("data-world-pair") || link.getAttribute("data-world-counterpart") || link.getAttribute("data-counterpart");
      var destination = marker === "brick" || marker === "3d" ? marker : (state.world === "brick" ? "3d" : "brick");
      if (sameUrl(link.href, window.location.href)) return;
      event.preventDefault();
      requestWorld({ world: destination, href: link.href, trigger: link });
    });
  });

  function consumeHandoff() {
    var handoff = null;
    try { handoff = JSON.parse(sessionStorage.getItem(HANDOFF_KEY)); } catch (_) {}
    try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_) {}
    if (!handoff || handoff.v !== 1 || handoff.world !== state.world || Date.now() - handoff.ts > 8000 || !sameUrl(handoff.to, window.location.href)) {
      root.classList.remove("portal-arrival-pending");
      return false;
    }
    if (motionQuery.matches || !portal) { clearPortalVisuals(); setInteractiveLock(false); return false; }
    state.runId += 1;
    state.phase = "transit";
    state.current = { world: state.world, href: null, trigger: null };
    portal.setAttribute("data-origin", handoff.origin || (state.world === "brick" ? "3d" : "brick"));
    portal.setAttribute("data-mode", "veil");
    portal.hidden = false;
    setInteractiveLock(true);
    drawPortalFrame(COMMIT_FRAME, state.world);
    root.classList.remove("portal-arrival-pending");
    playFrames(COMMIT_FRAME, FRAME_COUNT - 1, state.world, null, endPortal);
    return true;
  }

  function forcePortalReset() {
    state.runId += 1;
    state.phase = "idle";
    state.queued = null;
    state.current = null;
    state.trigger = null;
    state.navigating = false;
    clearPortalVisuals();
    setInteractiveLock(false);
  }

  window.addEventListener("pagehide", function (event) { if (event.persisted) forcePortalReset(); });
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    forcePortalReset();
    var restored = resolveWorld();
    commitWorld(restored === "brick" ? "brick" : "3d", { restore: false, persist: !gatewayPending(), updateUrl: !gatewayPending() });
  });
  doc.addEventListener("visibilitychange", function () {
    if (!doc.hidden || state.phase === "idle" || !state.current || state.navigating) return;
    var current = state.current;
    state.runId += 1;
    if (current.href) {
      rememberWorld(current.world, true);
      beginNavigation(current.href, current.world, current.origin || state.world);
    } else {
      commitWorld(current.world, { restore: true });
      endPortal();
    }
  });
  if (motionQuery.addEventListener) motionQuery.addEventListener("change", function (event) {
    if (event.matches && state.phase !== "idle" && state.current) {
      var current = state.current;
      forcePortalReset();
      if (current.href) {
        rememberWorld(current.world);
        window.location.assign(current.href);
      } else {
        commitWorld(current.world, { restore: true });
      }
    }
  });

  [].forEach.call(doc.querySelectorAll(".ba"), function (comparison) {
    var current = 50;
    function apply(value) { current = Math.max(4, Math.min(96, value)); comparison.style.setProperty("--pos", current.toFixed(1) + "%"); comparison.setAttribute("aria-valuenow", String(Math.round(current))); }
    function fromPointer(x) { var rect = comparison.getBoundingClientRect(); apply(((x - rect.left) / rect.width) * 100); }
    comparison.setAttribute("role", "slider"); comparison.setAttribute("tabindex", "0"); comparison.setAttribute("aria-valuemin", "4"); comparison.setAttribute("aria-valuemax", "96");
    if (!comparison.getAttribute("aria-label")) comparison.setAttribute("aria-label", "Compare the photo and finished figure");
    apply(50);
    comparison.addEventListener("keydown", function (event) {
      var step = event.shiftKey ? 10 : 5;
      if (event.key === "ArrowLeft") { apply(current - step); event.preventDefault(); }
      if (event.key === "ArrowRight") { apply(current + step); event.preventDefault(); }
      if (event.key === "Home") { apply(4); event.preventDefault(); }
      if (event.key === "End") { apply(96); event.preventDefault(); }
    });
    var dragging = false;
    comparison.addEventListener("pointerdown", function (event) { dragging = true; fromPointer(event.clientX); try { comparison.setPointerCapture(event.pointerId); } catch (_) {} });
    comparison.addEventListener("pointermove", function (event) { if (!dragging) return; fromPointer(event.clientX); if (event.cancelable) event.preventDefault(); });
    comparison.addEventListener("pointerup", function () { dragging = false; });
    comparison.addEventListener("pointercancel", function () { dragging = false; });
  });

  var burger = nav ? nav.querySelector(".nav__burger") : null;
  if (nav && burger) {
    function closeNavigation(returnFocus) {
      nav.classList.remove("open");
      burger.setAttribute("aria-expanded", "false");
      if (returnFocus) burger.focus({ preventScroll: true });
    }
    burger.addEventListener("click", function () { var open = nav.classList.toggle("open"); burger.setAttribute("aria-expanded", open ? "true" : "false"); });
    [].forEach.call(nav.querySelectorAll(".nav__links a"), function (link) { link.addEventListener("click", function () { closeNavigation(false); }); });
    doc.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.classList.contains("open")) { closeNavigation(true); event.preventDefault(); }
    });
    doc.addEventListener("pointerdown", function (event) {
      if (nav.classList.contains("open") && !nav.contains(event.target)) closeNavigation(false);
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 1280 && nav.classList.contains("open")) closeNavigation(false);
    }, { passive: true });
  }

  motionController = (function () {
    var revealObserver = null;
    var dynamicCleanups = [];
    var initialized = false;
    var compactTick = 0;
    var enhancementId = 0;

    function listen(target, type, handler, options) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, handler, options);
      dynamicCleanups.push(function () { target.removeEventListener(type, handler, options); });
    }

    function clearDynamic() {
      if (revealObserver) { revealObserver.disconnect(); revealObserver = null; }
      dynamicCleanups.splice(0).forEach(function (cleanup) { cleanup(); });
    }

    function belongsToActiveWorld(element) {
      if (!element || !element.isConnected || element.hidden || element.closest("[hidden]")) return false;
      var panel = element.closest("[data-world-panel]");
      return !panel || panel.getAttribute("data-world-panel") === state.world;
    }

    function queryActive(selector, scope) {
      var host = scope || main || doc;
      return [].slice.call(host.querySelectorAll(selector)).filter(belongsToActiveWorld);
    }

    function cleanText(value) {
      return String(value || "").replace(/\s+/g, " ").trim();
    }

    function ensureElementId(element, prefix) {
      if (!element) return "";
      if (!element.id) {
        enhancementId += 1;
        element.id = (prefix || "vp-enhancement") + "-" + enhancementId;
      }
      return element.id;
    }

    function activeWorldElement(element) {
      if (!element || !element.isConnected) return false;
      var panel = element.closest ? element.closest("[data-world-panel]") : null;
      return !panel || panel.getAttribute("data-world-panel") === state.world;
    }

    function reducedOrCoarse() {
      return motionQuery.matches || coarseQuery.matches;
    }

    function setMotionMode() {
      root.classList.add("motion-ready");
      root.classList.toggle("motion-reduced", motionQuery.matches);
      root.classList.toggle("motion-coarse", coarseQuery.matches);
    }

    function revealVariant(item) {
      if (item.matches(".step__media, .case-tile__media, .product-tile__media, .product-gallery__rail figure, [data-image-reveal]")) return "mask";
      if (item.matches(".offer-row, .product-fact, .material-strip__item, [data-line-reveal]")) return "line";
      if (item.matches(".eyebrow, [data-fade-reveal]")) return "fade";
      return "up";
    }

    function isCoreFormContent(element) {
      return !!element.closest("form[data-contact-form], form[data-custom-request]");
    }

    function prepareRevealMetadata() {
      queryActive(".case-tile__media, .product-tile__media, .step__media, .product-gallery__rail figure, [data-image-reveal]").forEach(function (media) {
        if (isCoreFormContent(media)) return;
        if (!media.hasAttribute("data-reveal")) media.setAttribute("data-reveal", "mask");
      });

      // R58：3D 世界原本一个板块都没接入这套入场动效，整条线看起来是静止的（用户说"干巴"）。
      // 这里只把容器加进来，子元素的 data-reveal / 交错延迟由下面的逻辑自动补，
      // prefers-reduced-motion 的兜底也照旧生效，不需要另写一套。
      var autoGroups = queryActive("[data-stagger], .case-grid, .offer-list, .steps--editorial, .product-facts, .product-gallery__rail, .proof-journey__steps, .quote-strip, .values__grid, .material-strip__inner, form.cform, .t3-macro, .t3-material__grid, .t3-closing__grid, .cat-grid, .s3-grid, .vp-trust__grid, .home-r15__detail-layout");
      autoGroups.forEach(function (group) {
        if (isCoreFormContent(group)) return;
        if (!group.hasAttribute("data-stagger")) group.setAttribute("data-stagger", "72");
        var delay = parseInt(group.getAttribute("data-stagger"), 10);
        if (!isFinite(delay)) delay = 72;
        [].slice.call(group.children).filter(function (child) {
          return child.nodeType === 1 && child.tagName !== "INPUT" && child.type !== "hidden" && !isCoreFormContent(child);
        }).forEach(function (child, index) {
          if (!child.hasAttribute("data-reveal")) child.setAttribute("data-reveal", revealVariant(child));
          child.setAttribute("data-reveal-order", String(index + 1));
          child.style.setProperty("--stagger-index", String(index));
          child.style.setProperty("--reveal-delay", Math.min(index * delay, 420) + "ms");
        });
      });

      queryActive("[data-reveal]").forEach(function (item) {
        if (isCoreFormContent(item)) return;
        if (!cleanText(item.getAttribute("data-reveal"))) item.setAttribute("data-reveal", revealVariant(item));
      });
    }

    function revealItem(item) {
      if (!item || item.classList.contains("is-revealed")) return;
      var image = item.tagName === "IMG" ? item : item.querySelector("img");
      if (item.getAttribute("data-reveal") === "mask" && image && !image.complete) {
        var finish = function () { item.classList.add("is-revealed"); };
        image.addEventListener("load", finish, { once: true });
        image.addEventListener("error", finish, { once: true });
        return;
      }
      item.classList.add("is-revealed");
    }

    function refreshRevealItems() {
      var items = queryActive("[data-reveal]").filter(function (item) { return !item.hidden && !item.closest("[hidden]") && !isCoreFormContent(item); });
      if (motionQuery.matches || !("IntersectionObserver" in window)) {
        items.forEach(revealItem);
        return;
      }
      items.forEach(function (item) {
        if (item.classList.contains("is-revealed")) return;
        if (item.getBoundingClientRect().top < window.innerHeight * 1.04) revealItem(item);
        else if (revealObserver) revealObserver.observe(item);
      });
    }

    function setupReveals() {
      prepareRevealMetadata();
      if (!motionQuery.matches && "IntersectionObserver" in window) {
        revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealItem(entry.target);
            revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      }
      refreshRevealItems();
      if (!motionQuery.matches) {
        var revealTick = 0;
        var requestRevealRefresh = function () {
          if (revealTick) return;
          revealTick = window.requestAnimationFrame(function () {
            revealTick = 0;
            refreshRevealItems();
          });
        };
        listen(window, "scroll", requestRevealRefresh, { passive: true });
        listen(window, "resize", requestRevealRefresh, { passive: true });
        dynamicCleanups.push(function () {
          if (revealTick) window.cancelAnimationFrame(revealTick);
        });
      }
    }

    function setupCompactNav() {
      if (!nav) return;
      // 滚过完整导航自身高度即切紧凑态吸附。用导航高度而非 hero 高度，
      // 两个世界 hero 高度不同(902/1240)会造成吸附时机不一致和数百 px 的导航真空区。
      var navFullHeight = 0;
      function compactThreshold() {
        // 只在展开态采样，否则紧凑态的 62px 会让阈值来回跳
        if (!nav.classList.contains("is-compact")) navFullHeight = nav.offsetHeight;
        return Math.max(48, (navFullHeight || 179) - 24);
      }
      function update() {
        compactTick = 0;
        var compact = window.scrollY > compactThreshold();
        nav.classList.toggle("is-compact", compact);
        root.classList.toggle("nav-compact", compact);
      }
      function requestUpdate() {
        if (!compactTick) compactTick = window.requestAnimationFrame(update);
      }
      function measureNavigation() {
        var wasCompact = nav.classList.contains("is-compact");
        nav.classList.remove("is-compact");
        root.classList.remove("nav-compact");
        navFullHeight = nav.offsetHeight;
        nav.classList.toggle("is-compact", wasCompact);
        root.classList.toggle("nav-compact", wasCompact);
      }
      listen(window, "scroll", requestUpdate, { passive: true });
      listen(window, "resize", function () { measureNavigation(); requestUpdate(); }, { passive: true });
      dynamicCleanups.push(function () {
        if (compactTick) window.cancelAnimationFrame(compactTick);
        compactTick = 0;
      });
      measureNavigation();
      update();
    }

    function resetTilt(element) {
      element.classList.remove("is-tilting");
      element.style.setProperty("--tilt-x", "0deg");
      element.style.setProperty("--tilt-y", "0deg");
      element.style.setProperty("--tilt-lift", "0px");
    }

    function setupTilts() {
      if (reducedOrCoarse()) return;
      queryActive("[data-tilt], .case-tile__media, .product-tile__media, .product-hero__media").filter(function (element) {
        var explicit = element.closest("[data-tilt]");
        return !explicit || explicit === element;
      }).forEach(function (element) {
        if (!element.hasAttribute("data-tilt")) element.setAttribute("data-tilt", "2.2");
        var maximum = parseFloat(element.getAttribute("data-tilt"));
        if (!isFinite(maximum)) maximum = 2.2;
        function move(event) {
          if (event.pointerType && event.pointerType !== "mouse") return;
          var rect = element.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var x = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
          var y = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
          element.classList.add("is-tilting");
          element.style.setProperty("--tilt-x", (-y * maximum).toFixed(2) + "deg");
          element.style.setProperty("--tilt-y", (x * maximum).toFixed(2) + "deg");
          element.style.setProperty("--tilt-lift", "-3px");
        }
        function leave() { resetTilt(element); }
        listen(element, "pointermove", move, { passive: true });
        listen(element, "pointerleave", leave, { passive: true });
        dynamicCleanups.push(leave);
      });
    }

    function resetMagnet(element) {
      element.classList.remove("is-magnetic");
      element.style.setProperty("--magnetic-x", "0px");
      element.style.setProperty("--magnetic-y", "0px");
    }

    function setupMagneticActions() {
      if (reducedOrCoarse()) return;
      queryActive("[data-magnetic], .hero__actions .btn--pink, .cta .btn--pink, .nav__cta", doc).forEach(function (element) {
        if (!element.hasAttribute("data-magnetic")) element.setAttribute("data-magnetic", "6");
        var maximum = parseFloat(element.getAttribute("data-magnetic"));
        if (!isFinite(maximum)) maximum = 6;
        function move(event) {
          if (event.pointerType && event.pointerType !== "mouse") return;
          var rect = element.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var x = ((event.clientX - rect.left) / rect.width - .5) * 2;
          var y = ((event.clientY - rect.top) / rect.height - .5) * 2;
          element.classList.add("is-magnetic");
          element.style.setProperty("--magnetic-x", (x * maximum).toFixed(2) + "px");
          element.style.setProperty("--magnetic-y", (y * maximum).toFixed(2) + "px");
        }
        function leave() { resetMagnet(element); }
        function focus() { element.classList.add("is-magnetic"); }
        listen(element, "pointermove", move, { passive: true });
        listen(element, "pointerleave", leave, { passive: true });
        listen(element, "focus", focus);
        listen(element, "blur", leave);
        dynamicCleanups.push(leave);
      });
    }

    function optionKeys(event, options, current, activate) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "ArrowUp" && event.key !== "ArrowDown" && event.key !== "Home" && event.key !== "End") return;
      var index = options.indexOf(current);
      if (event.key === "Home") index = 0;
      else if (event.key === "End") index = options.length - 1;
      else index = (index + (/Right|Down/.test(event.key) ? 1 : -1) + options.length) % options.length;
      event.preventDefault();
      activate(options[index], true);
      options[index].focus();
    }

    function setupGalleryFilters() {
      var galleryScope = main || doc;
      var controls = [].slice.call(galleryScope.querySelectorAll("[data-gallery-filter], [data-filter-gallery]"))
        .filter(activeWorldElement);
      if (!controls.length) return;
      /* Include cards hidden by a previous filter so refresh/world changes can
         always restore the complete set. queryActive intentionally omits them. */
      var cards = [].slice.call(galleryScope.querySelectorAll("[data-case-kind], [data-gallery-kind], [data-filter-kind]"))
        .filter(activeWorldElement);
      if (!cards.length) return;
      var results = [].slice.call(galleryScope.querySelectorAll("[data-gallery-results]"))
        .filter(activeWorldElement)[0] || null;
      if (!results) {
        results = doc.createElement("p");
        results.className = "sr-only";
        results.setAttribute("data-gallery-results", "");
        results.setAttribute("data-vp-generated-gallery-results", "");
        (controls[0].parentNode || galleryScope).appendChild(results);
      }
      if (results) { results.setAttribute("role", "status"); results.setAttribute("aria-live", "polite"); }

      function matches(card, filter) {
        if (!filter || filter === "all") return true;
        var kinds = cleanText(card.getAttribute("data-case-kind") || card.getAttribute("data-gallery-kind") || card.getAttribute("data-filter-kind")).toLowerCase().split(/[\s,|]+/);
        return kinds.indexOf(filter) !== -1;
      }

      function activate(control, userInitiated) {
        var filter = cleanText(control.getAttribute("data-gallery-filter") || control.getAttribute("data-filter-gallery")).toLowerCase() || "all";
        var shown = 0;
        var before = [];
        if (userInitiated && !motionQuery.matches && window.Element && Element.prototype.animate) {
          cards.forEach(function (card) { if (!card.hidden) before.push({ card: card, rect: card.getBoundingClientRect() }); });
        }
        controls.forEach(function (item) {
          var active = item === control;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", active ? "true" : "false");
          item.setAttribute("tabindex", active ? "0" : "-1");
        });
        cards.forEach(function (card) {
          var visible = matches(card, filter);
          card.hidden = !visible;
          card.setAttribute("aria-hidden", visible ? "false" : "true");
          card.classList.toggle("is-filter-match", visible);
          if (visible) shown += 1;
        });
        if (before.length) {
          window.requestAnimationFrame(function () {
            cards.forEach(function (card) {
              if (card.hidden) return;
              var previous = before.filter(function (entry) { return entry.card === card; })[0];
              var next = card.getBoundingClientRect();
              if (previous) {
                var dx = previous.rect.left - next.left;
                var dy = previous.rect.top - next.top;
                if (Math.abs(dx) > 1 || Math.abs(dy) > 1) card.animate([{ transform: "translate(" + dx + "px," + dy + "px)", opacity: .72 }, { transform: "translate(0,0)", opacity: 1 }], { duration: 360, easing: "cubic-bezier(.2,.75,.2,1)" });
              } else {
                card.animate([{ opacity: 0, transform: "translateY(14px)" }, { opacity: 1, transform: "translateY(0)" }], { duration: 260, easing: "ease-out" });
              }
            });
          });
        }
        if (results) results.textContent = shown + (shown === 1 ? " case shown" : " cases shown");
        if (userInitiated) announce("Gallery filter updated. " + shown + (shown === 1 ? " case shown." : " cases shown."));
        refreshRevealItems();
      }

      controls.forEach(function (control) {
        if (control.tagName !== "BUTTON") control.setAttribute("role", "button");
        listen(control, "click", function (event) { if (control.tagName === "A") event.preventDefault(); activate(control, true); });
        listen(control, "keydown", function (event) {
          if ((event.key === "Enter" || event.key === " ") && control.tagName !== "A" && control.tagName !== "BUTTON") {
            event.preventDefault();
            activate(control, true);
            return;
          }
          optionKeys(event, controls, control, activate);
        });
      });
      activate(controls.filter(function (item) { return item.classList.contains("is-active") || item.getAttribute("aria-pressed") === "true"; })[0] || controls[0], false);
    }

    function setupFilmstrips() {
      var scope = main || doc;
      var roots = [].slice.call(scope.querySelectorAll("[data-filmstrip], .inner-r14__filmstrip, .filmstrip"))
        .filter(activeWorldElement);
      [].slice.call(scope.querySelectorAll("[data-filmstrip-track]"))
        .filter(activeWorldElement)
        .forEach(function (track) {
          if (!track.closest("[data-filmstrip], .inner-r14__filmstrip, .filmstrip")) roots.push(track);
        });

      roots.forEach(function (filmstrip) {
        if (filmstrip.getAttribute("data-vp-filmstrip-ready") === "true") return;
        var track = filmstrip.matches("[data-filmstrip-track]") ? filmstrip : filmstrip.querySelector("[data-filmstrip-track], .inner-r14__filmstrip-track, .filmstrip__track");
        if (!track) return;
        filmstrip.setAttribute("data-vp-filmstrip-ready", "true");

        var previous = filmstrip.querySelector("[data-filmstrip-prev], [data-filmstrip-control='prev'], .filmstrip__prev");
        var next = filmstrip.querySelector("[data-filmstrip-next], [data-filmstrip-control='next'], .filmstrip__next");
        var trackId = ensureElementId(track, "vp-filmstrip");
        var tick = 0;
        var dragging = false;
        var moved = false;
        var suppressClick = false;
        var startX = 0;
        var startScroll = 0;
        var pointerId = null;

        if (!filmstrip.getAttribute("role")) filmstrip.setAttribute("role", "region");
        if (!filmstrip.getAttribute("aria-label") && !filmstrip.getAttribute("aria-labelledby")) filmstrip.setAttribute("aria-label", "Browse character examples");
        if (!track.hasAttribute("tabindex")) track.setAttribute("tabindex", "0");
        if (!track.getAttribute("role")) track.setAttribute("role", "group");
        if (!track.getAttribute("aria-roledescription")) track.setAttribute("aria-roledescription", "horizontal filmstrip");
        if (!track.getAttribute("aria-label")) track.setAttribute("aria-label", "Use left and right arrow keys to browse");

        [previous, next].forEach(function (control) {
          if (!control) return;
          if (control.tagName === "BUTTON" && !control.getAttribute("type")) control.setAttribute("type", "button");
          control.setAttribute("aria-controls", trackId);
        });

        function items() {
          return [].slice.call(track.children).filter(function (item) { return item.nodeType === 1 && !item.hidden; });
        }

        function closestItemIndex() {
          var available = items();
          if (!available.length) return 0;
          var center = track.scrollLeft + track.clientWidth * .5;
          var bestIndex = 0;
          var bestDistance = Infinity;
          available.forEach(function (item, index) {
            var itemCenter = item.offsetLeft + item.offsetWidth * .5;
            var distance = Math.abs(itemCenter - center);
            if (distance < bestDistance) { bestDistance = distance; bestIndex = index; }
          });
          return bestIndex;
        }

        function setControlState(control, disabled) {
          if (!control) return;
          control.setAttribute("aria-disabled", disabled ? "true" : "false");
          if (control.tagName === "BUTTON") control.disabled = disabled;
        }

        function update() {
          tick = 0;
          var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          var progress = maximum ? Math.max(0, Math.min(1, track.scrollLeft / maximum)) : 0;
          var atStart = maximum < 2 || track.scrollLeft <= 2;
          var atEnd = maximum < 2 || track.scrollLeft >= maximum - 2;
          filmstrip.style.setProperty("--filmstrip-progress", (progress * 100).toFixed(2) + "%");
          filmstrip.setAttribute("data-filmstrip-start", atStart ? "true" : "false");
          filmstrip.setAttribute("data-filmstrip-end", atEnd ? "true" : "false");
          setControlState(previous, atStart);
          setControlState(next, atEnd);
        }

        function requestUpdate() {
          if (tick) return;
          tick = window.requestAnimationFrame(update);
        }

        function scrollToItem(index, userInitiated) {
          var available = items();
          if (!available.length) return;
          index = Math.max(0, Math.min(available.length - 1, index));
          var item = available[index];
          var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          var left = Math.max(0, Math.min(maximum, item.offsetLeft - (track.clientWidth - item.offsetWidth) * .5));
          if (track.scrollTo) track.scrollTo({ left: left, behavior: motionQuery.matches ? "auto" : "smooth" });
          else track.scrollLeft = left;
          if (userInitiated) announce("Showing item " + (index + 1) + " of " + available.length + ".");
          requestUpdate();
        }

        function browse(direction) {
          scrollToItem(closestItemIndex() + direction, true);
        }

        if (previous) listen(previous, "click", function (event) {
          if (previous.getAttribute("aria-disabled") === "true") { event.preventDefault(); return; }
          if (previous.tagName === "A") event.preventDefault();
          browse(-1);
        });
        if (next) listen(next, "click", function (event) {
          if (next.getAttribute("aria-disabled") === "true") { event.preventDefault(); return; }
          if (next.tagName === "A") event.preventDefault();
          browse(1);
        });

        listen(track, "keydown", function (event) {
          if (event.target !== track && !event.target.hasAttribute("data-filmstrip-item")) return;
          if (event.key === "ArrowLeft" || event.key === "PageUp") { event.preventDefault(); browse(-1); }
          else if (event.key === "ArrowRight" || event.key === "PageDown") { event.preventDefault(); browse(1); }
          else if (event.key === "Home") { event.preventDefault(); scrollToItem(0, true); }
          else if (event.key === "End") { event.preventDefault(); scrollToItem(items().length - 1, true); }
        });

        listen(track, "pointerdown", function (event) {
          if (event.button !== undefined && event.button !== 0) return;
          if (event.isPrimary === false) return;
          if (event.pointerType === "touch") return; /* native momentum scrolling is better on touch */
          dragging = true;
          moved = false;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScroll = track.scrollLeft;
          try { track.setPointerCapture(pointerId); } catch (_) {}
        });
        listen(track, "dragstart", function (event) { event.preventDefault(); });
        listen(track, "pointermove", function (event) {
          if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
          var delta = event.clientX - startX;
          if (!moved && Math.abs(delta) < 5) return;
          moved = true;
          filmstrip.classList.add("is-dragging");
          track.classList.add("is-dragging");
          track.scrollLeft = startScroll - delta;
          if (event.cancelable) event.preventDefault();
        });

        function endDrag(event) {
          if (!dragging) return;
          if (event && pointerId !== null && event.pointerId !== pointerId) return;
          dragging = false;
          suppressClick = moved;
          filmstrip.classList.remove("is-dragging");
          track.classList.remove("is-dragging");
          try { if (pointerId !== null && track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId); } catch (_) {}
          pointerId = null;
          requestUpdate();
          window.setTimeout(function () { suppressClick = false; }, 0);
        }
        listen(track, "pointerup", endDrag);
        listen(track, "pointercancel", endDrag);
        listen(track, "lostpointercapture", endDrag);
        listen(track, "click", function (event) {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }, true);
        listen(track, "scroll", requestUpdate, { passive: true });
        listen(window, "resize", requestUpdate, { passive: true });

        var resizeObserver = null;
        if ("ResizeObserver" in window) {
          resizeObserver = new ResizeObserver(requestUpdate);
          resizeObserver.observe(track);
          dynamicCleanups.push(function () { resizeObserver.disconnect(); });
        }
        dynamicCleanups.push(function () {
          if (tick) window.cancelAnimationFrame(tick);
          filmstrip.removeAttribute("data-vp-filmstrip-ready");
          filmstrip.classList.remove("is-dragging");
          track.classList.remove("is-dragging");
        });
        update();
      });
    }

    function setupUploadDropzones() {
      var scope = main || doc;
      var dropzones = [].slice.call(scope.querySelectorAll("[data-upload-dropzone], [data-dropzone], .inner-r14__dropzone, .upload-dropzone, .cform__upload"))
        .filter(activeWorldElement);

      dropzones.forEach(function (dropzone) {
        if (dropzone.getAttribute("data-vp-upload-ready") === "true") return;
        var input = dropzone.matches("input[type='file']") ? dropzone : dropzone.querySelector("input[type='file']");
        if (!input) return;
        dropzone.setAttribute("data-vp-upload-ready", "true");

        var uploadRoot = dropzone.closest("[data-upload-root], .inner-r14__upload-card, .cform__row") || dropzone.parentElement || dropzone;
        var statusNode = dropzone.querySelector("[data-upload-status]") || uploadRoot.querySelector("[data-upload-status]");
        var nameNode = dropzone.querySelector("[data-upload-name], [data-upload-filename]");
        var preview = dropzone.querySelector("[data-upload-preview]");
        var previewImage = null;
        var dragDepth = 0;
        var currentUrl = "";
        var previewToken = 0;

        if (!nameNode) {
          nameNode = doc.createElement("strong");
          nameNode.className = "inner-r14__upload-name upload-dropzone__name";
          nameNode.setAttribute("data-upload-name", "");
          nameNode.setAttribute("data-vp-generated-upload-name", "");
          nameNode.hidden = true;
          dropzone.appendChild(nameNode);
        }
        var emptyName = cleanText(nameNode.textContent) || "No file chosen";
        if (!statusNode) {
          statusNode = doc.createElement("small");
          statusNode.className = "inner-r14__upload-status upload-dropzone__status";
          statusNode.setAttribute("data-upload-status", "");
          statusNode.setAttribute("data-vp-generated-upload-status", "");
          dropzone.appendChild(statusNode);
        }
        if (!preview) {
          preview = doc.createElement("span");
          preview.className = "inner-r14__upload-preview upload-dropzone__preview";
          preview.setAttribute("data-upload-preview", "");
          preview.setAttribute("data-vp-generated-upload-preview", "");
          preview.hidden = true;
          dropzone.insertBefore(preview, nameNode);
        }
        previewImage = preview.matches("img") ? preview : preview.querySelector("img");
        if (!previewImage) {
          previewImage = doc.createElement("img");
          previewImage.width = 96;
          previewImage.height = 96;
          previewImage.alt = "Selected reference preview";
          preview.appendChild(previewImage);
        }

        var statusId = ensureElementId(statusNode, "vp-upload-status");
        var describedBy = cleanText(input.getAttribute("aria-describedby"));
        if (describedBy.split(/\s+/).indexOf(statusId) < 0) input.setAttribute("aria-describedby", cleanText(describedBy + " " + statusId));
        statusNode.setAttribute("role", "status");
        statusNode.setAttribute("aria-live", "polite");
        statusNode.setAttribute("aria-atomic", "true");
        if (dropzone.tagName !== "LABEL" && !dropzone.hasAttribute("tabindex")) dropzone.setAttribute("tabindex", "0");
        if (dropzone.tagName !== "LABEL" && !dropzone.getAttribute("role")) dropzone.setAttribute("role", "button");

        function revokePreviewUrl() {
          if (!currentUrl || !window.URL || !window.URL.revokeObjectURL) return;
          window.URL.revokeObjectURL(currentUrl);
          currentUrl = "";
        }

        function clearPreview() {
          previewToken += 1;
          revokePreviewUrl();
          if (previewImage) previewImage.removeAttribute("src");
          if (preview) preview.hidden = true;
        }

        function maximumBytes() {
          var rawBytes = parseFloat(dropzone.getAttribute("data-upload-max-bytes") || input.getAttribute("data-upload-max-bytes"));
          if (isFinite(rawBytes) && rawBytes > 0) return rawBytes;
          var rawMb = parseFloat(dropzone.getAttribute("data-upload-max-mb") || input.getAttribute("data-upload-max-mb"));
          return (isFinite(rawMb) && rawMb > 0 ? rawMb : 15) * 1024 * 1024;
        }

        function readableSize(bytes) {
          if (bytes < 1024) return bytes + " B";
          if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(bytes < 10240 ? 1 : 0) + " KB";
          return (bytes / (1024 * 1024)).toFixed(1) + " MB";
        }

        function safeImage(file) {
          var name = String(file.name || "").toLowerCase();
          var type = String(file.type || "").toLowerCase();
          var safeType = /^(image\/(jpeg|png|webp))$/.test(type);
          var safeExtension = /\.(jpe?g|png|webp)$/.test(name);
          if (type && type !== "application/octet-stream" && !safeType) return false;
          if (!safeType && !safeExtension) return false;
          var accept = cleanText(input.getAttribute("accept")).toLowerCase();
          if (!accept) return true;
          return accept.split(",").some(function (entry) {
            entry = cleanText(entry);
            if (!entry) return false;
            if (entry === "image/*") return true;
            if (entry.charAt(0) === ".") return name.slice(-entry.length) === entry;
            if (!type && entry === "image/jpeg") return /\.jpe?g$/.test(name);
            if (!type && entry === "image/png") return /\.png$/.test(name);
            if (!type && entry === "image/webp") return /\.webp$/.test(name);
            return type === entry;
          });
        }

        function setUploadState(kind, message) {
          dropzone.classList.remove("is-ready", "has-file", "has-error", "has-warning");
          if (kind === "ready") dropzone.classList.add("is-ready", "has-file");
          else if (kind === "error") dropzone.classList.add("has-error");
          else if (kind === "warning") dropzone.classList.add("has-warning", "has-file");
          dropzone.setAttribute("data-upload-state", kind);
          input.setAttribute("aria-invalid", kind === "error" ? "true" : "false");
          statusNode.textContent = message;
        }

        function resetUpload() {
          clearPreview();
          nameNode.textContent = emptyName;
          nameNode.hidden = nameNode.hasAttribute("data-vp-generated-upload-name");
          input.setCustomValidity("");
          setUploadState("empty", "No reference photo selected yet.");
        }

        function showFile(file, attached) {
          clearPreview();
          if (!file) { resetUpload(); return; }
          nameNode.textContent = file.name || "Selected photo";
          nameNode.hidden = false;

          if (!safeImage(file)) {
            input.setCustomValidity("Choose a supported JPG, PNG or WebP image.");
            setUploadState("error", "This file type cannot be previewed safely. Choose a JPG, PNG or WebP image.");
            announce("Unsupported reference photo type.");
            return;
          }
          if (file.size > maximumBytes()) {
            input.setCustomValidity("Choose an image smaller than " + readableSize(maximumBytes()) + ".");
            setUploadState("error", "This photo is " + readableSize(file.size) + ". Choose one smaller than " + readableSize(maximumBytes()) + ".");
            announce("Reference photo is too large.");
            return;
          }

          input.setCustomValidity("");
          var safeMessage = (file.name || "Photo") + " · " + readableSize(file.size) + ". Previewed only in this browser; the final upload is completed in the order flow.";
          if (!attached) safeMessage += " Use the file picker if your browser did not attach the dropped file.";
          setUploadState(attached ? "ready" : "warning", safeMessage);

          if (previewImage && window.URL && window.URL.createObjectURL) {
            var token = previewToken;
            currentUrl = window.URL.createObjectURL(file);
            previewImage.alt = "Preview of " + (file.name || "selected reference photo");
            previewImage.addEventListener("load", function () { if (token === previewToken) revokePreviewUrl(); }, { once: true });
            previewImage.addEventListener("error", function () {
              if (token !== previewToken) return;
              revokePreviewUrl();
              preview.hidden = true;
              statusNode.textContent = safeMessage + " Preview is unavailable, but the selected file is unchanged.";
            }, { once: true });
            previewImage.src = currentUrl;
            preview.hidden = false;
          }
          announce("Reference photo selected: " + (file.name || "photo") + ".");
        }

        function attachDroppedFile(file) {
          if (!file || !("DataTransfer" in window)) return false;
          try {
            var transfer = new DataTransfer();
            transfer.items.add(file);
            input.files = transfer.files;
            return !!(input.files && input.files.length && input.files[0].name === file.name && input.files[0].size === file.size);
          } catch (_) { return false; }
        }

        listen(input, "change", function () { showFile(input.files && input.files[0], true); });
        listen(dropzone, "dragenter", function (event) {
          if (!event.dataTransfer) return;
          event.preventDefault();
          dragDepth += 1;
          dropzone.classList.add("is-dragover", "is-dragging");
          dropzone.setAttribute("data-upload-dragging", "true");
        });
        listen(dropzone, "dragover", function (event) {
          if (!event.dataTransfer) return;
          event.preventDefault();
          event.dataTransfer.dropEffect = "copy";
        });
        listen(dropzone, "dragleave", function () {
          dragDepth = Math.max(0, dragDepth - 1);
          if (dragDepth) return;
          dropzone.classList.remove("is-dragover", "is-dragging");
          dropzone.removeAttribute("data-upload-dragging");
        });
        listen(dropzone, "drop", function (event) {
          event.preventDefault();
          dragDepth = 0;
          dropzone.classList.remove("is-dragover", "is-dragging");
          dropzone.removeAttribute("data-upload-dragging");
          var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
          if (!file) { setUploadState("error", "No file was found in that drop. Try the file picker instead."); return; }
          showFile(file, attachDroppedFile(file));
        });
        if (dropzone.tagName !== "LABEL") listen(dropzone, "click", function (event) {
          if (event.target === input || event.target.closest("a, button, input, select, textarea")) return;
          input.click();
        });
        listen(dropzone, "keydown", function (event) {
          if (event.target !== dropzone || (event.key !== "Enter" && event.key !== " ")) return;
          event.preventDefault();
          input.click();
        });
        if (input.form) listen(input.form, "reset", function () { window.setTimeout(resetUpload, 0); });
        dynamicCleanups.push(function () {
          previewToken += 1;
          revokePreviewUrl();
          dropzone.removeAttribute("data-vp-upload-ready");
          dropzone.classList.remove("is-dragover", "is-dragging");
          dropzone.removeAttribute("data-upload-dragging");
        });

        if (input.files && input.files[0]) showFile(input.files[0], true);
        else resetUpload();
      });
    }

    function setupStepChapters() {
      var scope = main || doc;
      var navs = [].slice.call(scope.querySelectorAll("[data-step-chapters], [data-chapter-nav], [data-step-nav], .inner-r14__chapters, .inner-r14__chapter-nav, .step-chapters"))
        .filter(activeWorldElement);

      navs.forEach(function (chapterNav) {
        if (chapterNav.getAttribute("data-vp-chapters-ready") === "true") return;
        var host = chapterNav.closest("[data-chapter-root], [data-step-root], [data-process-board], [data-world-panel]") || main || doc;
        var controls = [].slice.call(chapterNav.querySelectorAll("[data-chapter-target], [data-step-target], [data-step-jump], [data-chapter-control]"));
        if (!controls.length && chapterNav !== host) controls = [].slice.call(chapterNav.querySelectorAll("a[href^='#'], button"));
        if (!controls.length) return;
        var sections = [].slice.call(host.querySelectorAll("[data-step-chapter], [data-chapter-section]"))
          .filter(activeWorldElement);
        if (!sections.length) sections = [].slice.call(host.querySelectorAll("[data-process-step]"));
        if (!sections.length) return;

        function targetForControl(control, index) {
          var raw = cleanText(control.getAttribute("data-chapter-target") || control.getAttribute("data-step-target") || control.getAttribute("data-step-jump") || control.getAttribute("aria-controls"));
          if (!raw && control.tagName === "A") raw = cleanText(control.getAttribute("href"));
          if (raw && raw.indexOf("#") >= 0) raw = raw.slice(raw.indexOf("#") + 1);
          if (raw && /^\d+$/.test(raw)) return sections[Math.max(0, Math.min(sections.length - 1, parseInt(raw, 10) - 1))] || null;
          if (raw) {
            try {
              var byId = doc.getElementById(decodeURIComponent(raw));
              if (byId && host.contains(byId)) return byId;
            } catch (_) {}
          }
          return sections[index] || null;
        }

        var pairs = controls.map(function (control, index) { return { control: control, target: targetForControl(control, index) }; })
          .filter(function (pair) { return !!pair.target; });
        if (!pairs.length) return;
        controls = pairs.map(function (pair) { return pair.control; });
        sections = pairs.map(function (pair) { return pair.target; });
        var controlGroup = controls[0].closest("[data-chapter-nav], [data-step-nav], .inner-r14__hero-rail, .inner-r14__chapters, .inner-r14__chapter-nav") || chapterNav;
        chapterNav.setAttribute("data-vp-chapters-ready", "true");
        if (!controlGroup.getAttribute("aria-label")) controlGroup.setAttribute("aria-label", "Page chapters");

        var progress = host.querySelector("[data-chapter-progress], [data-step-progress]") || chapterNav.querySelector("[data-chapter-progress], [data-step-progress]");
        var activeIndex = -1;
        var tick = 0;
        var chapterScroller = null;
        var boundChapterScroller = null;

        sections.forEach(function (section, index) {
          var id = ensureElementId(section, "vp-chapter");
          controls[index].setAttribute("aria-controls", id);
          if (controls[index].tagName !== "A" && controls[index].tagName !== "BUTTON") controls[index].setAttribute("role", "button");
        });

        function activate(index, userInitiated) {
          index = Math.max(0, Math.min(sections.length - 1, index));
          if (index === activeIndex && !userInitiated) return;
          activeIndex = index;
          var percent = sections.length > 1 ? (index / (sections.length - 1)) * 100 : 100;
          host.setAttribute("data-active-chapter", String(index + 1));
          controlGroup.setAttribute("data-active-chapter", String(index + 1));
          host.style.setProperty("--chapter-progress", percent.toFixed(2) + "%");
          controlGroup.style.setProperty("--chapter-progress", percent.toFixed(2) + "%");
          controls.forEach(function (control, controlIndex) {
            var active = controlIndex === index;
            control.classList.toggle("is-active", active);
            control.setAttribute("tabindex", active ? "0" : "-1");
            if (active) control.setAttribute("aria-current", "step");
            else control.removeAttribute("aria-current");
          });
          sections.forEach(function (section, sectionIndex) { section.classList.toggle("is-chapter-active", sectionIndex === index); });
          if (progress) {
            progress.style.setProperty("--progress", percent.toFixed(2) + "%");
            if (progress.tagName === "PROGRESS") { progress.max = sections.length; progress.value = index + 1; }
            else {
              progress.setAttribute("role", "progressbar");
              progress.setAttribute("aria-valuemin", "1");
              progress.setAttribute("aria-valuemax", String(sections.length));
              progress.setAttribute("aria-valuenow", String(index + 1));
              if (!progress.children.length) progress.textContent = String(index + 1).padStart(2, "0");
            }
          }
          if (userInitiated) announce("Step " + (index + 1) + " of " + sections.length + ".");
        }

        function goTo(index, focusControl) {
          index = Math.max(0, Math.min(sections.length - 1, index));
          activate(index, true);
          sections[index].scrollIntoView({ behavior: motionQuery.matches ? "auto" : "smooth", block: "start" });
          if (focusControl) controls[index].focus();
        }

        function findHorizontalScroller() {
          var candidate = sections[0] ? sections[0].parentElement : null;
          while (candidate && candidate !== host.parentElement) {
            var overflowX = window.getComputedStyle ? window.getComputedStyle(candidate).overflowX : "";
            if (candidate.scrollWidth > candidate.clientWidth + 3 && /auto|scroll/.test(overflowX)) return candidate;
            if (candidate === host) break;
            candidate = candidate.parentElement;
          }
          return null;
        }

        function ensureChapterScroller() {
          chapterScroller = findHorizontalScroller();
          if (chapterScroller && chapterScroller !== boundChapterScroller) {
            boundChapterScroller = chapterScroller;
            listen(chapterScroller, "scroll", requestChapterUpdate, { passive: true });
          }
          return chapterScroller;
        }

        function closestChapterIndex() {
          ensureChapterScroller();
          if (chapterScroller) {
            var scrollerRect = chapterScroller.getBoundingClientRect();
            var horizontalTarget = scrollerRect.left + scrollerRect.width * .5;
            var horizontalBest = 0;
            var horizontalDistance = Infinity;
            sections.forEach(function (section, index) {
              var rect = section.getBoundingClientRect();
              var distance = Math.abs(rect.left + rect.width * .5 - horizontalTarget);
              if (distance < horizontalDistance) { horizontalDistance = distance; horizontalBest = index; }
            });
            return horizontalBest;
          }
          var firstTop = sections[0].getBoundingClientRect().top;
          var verticallyDistinct = sections.some(function (section) { return Math.abs(section.getBoundingClientRect().top - firstTop) > 8; });
          return verticallyDistinct ? closestViewportStep(sections) : Math.max(0, activeIndex);
        }

        function updateFromViewport() {
          tick = 0;
          var visible = sections.filter(function (section) {
            var rect = section.getBoundingClientRect();
            return rect.bottom > 0 && rect.top < window.innerHeight;
          });
          if (!visible.length) return;
          var closest = closestChapterIndex();
          activate(closest, false);
        }

        function requestChapterUpdate() {
          if (!tick) tick = window.requestAnimationFrame(updateFromViewport);
        }

        controls.forEach(function (control, index) {
          if (control.tagName === "BUTTON" && !control.getAttribute("type")) control.setAttribute("type", "button");
          listen(control, "click", function (event) {
            if (control.tagName === "A") event.preventDefault();
            goTo(index, false);
          });
          listen(control, "keydown", function (event) {
            var targetIndex = index;
            if (event.key === "Home") targetIndex = 0;
            else if (event.key === "End") targetIndex = controls.length - 1;
            else if (event.key === "ArrowRight" || event.key === "ArrowDown") targetIndex = (index + 1) % controls.length;
            else if (event.key === "ArrowLeft" || event.key === "ArrowUp") targetIndex = (index - 1 + controls.length) % controls.length;
            else if ((event.key === "Enter" || event.key === " ") && control.tagName !== "A" && control.tagName !== "BUTTON") { event.preventDefault(); goTo(index, false); return; }
            else return;
            event.preventDefault();
            goTo(targetIndex, true);
          });
        });
        listen(window, "scroll", requestChapterUpdate, { passive: true });
        listen(window, "resize", requestChapterUpdate, { passive: true });
        ensureChapterScroller();
        dynamicCleanups.push(function () {
          if (tick) window.cancelAnimationFrame(tick);
          chapterNav.removeAttribute("data-vp-chapters-ready");
        });

        var hashIndex = -1;
        if (window.location.hash) hashIndex = sections.map(function (section) { return "#" + section.id; }).indexOf(window.location.hash);
        activate(hashIndex >= 0 ? hashIndex : closestViewportStep(sections), false);
      });
    }

    function castHrefWithPack(href, pack) {
      var hashAt = href.indexOf("#");
      var hash = hashAt < 0 ? "" : href.slice(hashAt);
      var pathAndQuery = hashAt < 0 ? href : href.slice(0, hashAt);
      var queryAt = pathAndQuery.indexOf("?");
      var path = queryAt < 0 ? pathAndQuery : pathAndQuery.slice(0, queryAt);
      var query = new URLSearchParams(queryAt < 0 ? "" : pathAndQuery.slice(queryAt + 1));
      query.delete("pack");
      if (pack) query.set("pack", pack);
      var search = query.toString();
      return path + (search ? "?" + search : "") + hash;
    }

    // One owner for every cast input: click, keyboard, thumbnail and remount.
    // Price/link state is immediate; the two comparison images commit together.
    function mountCastChooser(chooser) {
      if (chooser.__vpCastChooser) return chooser.__vpCastChooser;
      var choices = [].slice.call(chooser.querySelectorAll("[data-cast-option]"));
      if (!choices.length) return null;
      function target(selector) {
        return [].slice.call(chooser.querySelectorAll(selector)).filter(function (item) { return !item.hasAttribute("data-cast-option"); })[0] || null;
      }
      var imageTarget = target("[data-cast-image], [data-cast-image-target]");
      var beforeTarget = target("[data-cast-before]");
      var nameTarget = target("[data-cast-name], [data-cast-name-target]");
      var priceTarget = target("[data-cast-price], [data-cast-price-target]"); var wasTarget = target("[data-cast-was]"), offTarget = target("[data-cast-off]");
      var noteTarget = target("[data-cast-note], [data-cast-note-target]");
      var linkTarget = target("[data-cast-href], [data-cast-link-target]");
      var summary = target("[data-cast-summary]");
      var preview = target("[data-addon-preview]");
      var gift = target("[data-finish-gift]");
      var stage = chooser.querySelector("[data-cast-stage], .ba") || chooser;
      var thumbs = [].slice.call(chooser.querySelectorAll("[data-r9-thumb]"));
      var addons = [].slice.call(chooser.querySelectorAll("[data-addon]"));
      var cleanups = [], requests = [], imageTimer = 0, imageToken = 0, disposed = false;
      var imageStatus = chooser.querySelector("[data-cast-image-status]");
      var createdStatus = false;
      var activeChoice = choices.filter(function (item) { return item.getAttribute("aria-pressed") === "true" || item.classList.contains("is-active"); })[0] || choices[0];
      var previousIndex = choices.indexOf(activeChoice);
      if (summary) { summary.setAttribute("aria-live", "polite"); summary.setAttribute("aria-atomic", "true"); }

      function on(element, type, handler) {
        element.addEventListener(type, handler);
        cleanups.push(function () { element.removeEventListener(type, handler); });
      }
      function selectedAddon() {
        return addons.filter(function (item) { return item.getAttribute("aria-checked") === "true"; })[0] || null;
      }
      function syncPurchase() {
        var raw = cleanText(activeChoice.getAttribute("data-price") || activeChoice.getAttribute("data-cast-price"));
        var base = parseFloat(raw.replace(/[^0-9.]/g, ""));
        var picked = selectedAddon();
        var delta = picked ? parseFloat(picked.getAttribute("data-addon-delta")) || 0 : 0;
        var vpFx = addons.length ? vpFxPrice(raw, delta) : null;
        var price = vpFx !== null ? vpFx : addons.length && isFinite(base) ? "$" + (Math.round((base + delta) * 100) / 100) : raw;
        if (priceTarget) priceTarget.textContent = price; if (wasTarget) { var wasTxt = vpWasText(price); (wasTarget.querySelector("[data-vp-amt]") || wasTarget).textContent = wasTxt; wasTarget.hidden = !wasTxt; if (offTarget) offTarget.hidden = !wasTxt; }
        if (addons.length) {
          if (preview) preview.textContent = picked ? (picked.getAttribute("data-addon-pack") === "case" ? T('js.app.builder_case_added', picked.getAttribute("data-addon-label") + " added.") : T('js.app.builder_gift_added', picked.getAttribute("data-addon-label") + " added.")) : T('js.app.builder_classic', "Classic build \u2014 display base included, no extras.");
          if (gift) gift.hidden = !picked || picked.getAttribute("data-addon-pack") !== "gift"; // 欧洲改造 leftovers/options：按 data-addon-pack 判断，不比显示文字（德法 label 会翻译）
        }
        var href = cleanText(activeChoice.getAttribute("data-href") || activeChoice.getAttribute("data-cast-href"));
        if (linkTarget && href) {
          linkTarget.setAttribute("data-finish-base-href", href);
          linkTarget.setAttribute("href", addons.length ? castHrefWithPack(href, picked ? picked.getAttribute("data-addon-pack") : "") : href);
        }
        return price;
      }
      function cancelImages() {
        imageToken += 1;
        requests.forEach(function (request) { request.onload = request.onerror = null; });
        requests = [];
        if (imageTimer) window.clearTimeout(imageTimer);
        imageTimer = 0;
        if (imageTarget) imageTarget.classList.remove("is-changing");
        stage.setAttribute("aria-busy", "false");
      }
      function setImageStatus(message) {
        if (message && !imageStatus) {
          imageStatus = chooser.ownerDocument.createElement("p");
          imageStatus.setAttribute("data-cast-image-status", "");
          imageStatus.setAttribute("role", "status");
          imageStatus.setAttribute("aria-live", "polite");
          (chooser.querySelector(".home-r9__builder-media") || chooser).appendChild(imageStatus);
          createdStatus = true;
        }
        if (imageStatus) { imageStatus.textContent = message; imageStatus.hidden = !message; }
      }
      function syncImages(option, source, alt) {
        cancelImages();
        setImageStatus("");
        var token = imageToken;
        var before = cleanText(option.getAttribute("data-before-src"));
        var images = [];
        if (imageTarget && source) images.push({ element: imageTarget, source: source, alt: alt });
        if (beforeTarget && before) images.push({ element: beforeTarget, source: before });
        var pending = images.filter(function (item) { return item.element.getAttribute("src") !== item.source; });
        var remaining = pending.length, settled = false;
        function current() { return !disposed && token === imageToken && !settled; }
        function finish(success) {
          if (!current()) return;
          settled = true;
          if (success) images.forEach(function (item) {
            item.element.setAttribute("src", item.source);
            if (item.alt) item.element.setAttribute("alt", item.alt);
          });
          cancelImages();
          chooser.setAttribute("data-cast-image-state", success ? "ready" : "error");
          if (!success) {
            var message = "Comparison could not be updated. Previous images remain shown. Select this cast again to retry.";
            setImageStatus(message);
            announce(message);
          }
        }
        if (!remaining) { finish(true); return; }
        chooser.setAttribute("data-cast-image-state", "loading");
        stage.setAttribute("aria-busy", "true");
        if (typeof window.Image !== "function") { finish(false); return; }
        if (imageTarget) imageTarget.classList.add("is-changing");
        imageTimer = window.setTimeout(function () { finish(false); }, 12000);
        requests = pending.map(function () { return new window.Image(); });
        requests.slice().forEach(function (request, index) {
          if (!current()) return;
          var loaded = false;
          request.onload = function () {
            if (!current() || loaded) return;
            loaded = true;
            if (typeof request.naturalWidth === "number" && request.naturalWidth <= 0) { finish(false); return; }
            remaining -= 1;
            if (!remaining) finish(true);
          };
          request.onerror = function () { finish(false); };
          request.src = pending[index].source;
        });
      }
      function activate(option, userInitiated) {
        if (disposed || choices.indexOf(option) < 0) return;
        activeChoice = option;
        var name = cleanText(option.getAttribute("data-name") || option.getAttribute("data-cast-name"));
        var note = cleanText(option.getAttribute("data-note") || option.getAttribute("data-cast-note"));
        var source = cleanText(option.getAttribute("data-image-src") || option.getAttribute("data-cast-image"));
        var alt = cleanText(option.getAttribute("data-image-alt") || option.getAttribute("data-cast-alt")) || name;
        var value = cleanText(option.getAttribute("data-cast-option")) || name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
        var nextIndex = choices.indexOf(option);
        stage.setAttribute("data-swap-direction", nextIndex >= previousIndex ? "next" : "previous");
        choices.forEach(function (item) {
          var active = item === option;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", active ? "true" : "false");
          item.setAttribute("tabindex", active ? "0" : "-1");
        });
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute("data-image") === source;
          thumb.classList.toggle("is-active", active);
          thumb.setAttribute("aria-pressed", active ? "true" : "false");
        });
        chooser.setAttribute("data-active-cast", value);
        if (nameTarget) nameTarget.textContent = name;
        if (noteTarget) noteTarget.textContent = note;
        var price = syncPurchase();
        if (summary && !summary.querySelector("[data-cast-name], [data-cast-price], [data-cast-note], [data-cast-href], [data-cast-link-target]")) summary.textContent = [name, price, note].filter(Boolean).join(" · ");
        if (userInitiated && priceTarget && !motionQuery.matches && priceTarget.animate) priceTarget.animate([{ opacity: .25, transform: "translateY(8px)" }, { opacity: 1, transform: "translateY(0)" }], { duration: 220, easing: "ease-out" });
        // Older finish controls still receive the same keyboard/click lifecycle.
        chooser.dispatchEvent(new window.CustomEvent("vp:castchange"));
        if (userInitiated) announce((name || "Cast option") + " selected" + (price ? " at " + price : "") + ".");
        syncImages(option, source, alt);
        previousIndex = nextIndex;
      }
      choices.forEach(function (option) {
        if (option.getAttribute("role") !== "button") option.setAttribute("role", "button");
        on(option, "click", function (event) { if (option.tagName === "A") event.preventDefault(); activate(option, true); });
        on(option, "keydown", function (event) { optionKeys(event, choices, option, activate); });
      });
      function activateThumb(thumb) {
        var option = choices.filter(function (item) { return (item.getAttribute("data-image-src") || item.getAttribute("data-cast-image")) === thumb.getAttribute("data-image"); })[0];
        if (option) activate(option, true);
      }
      thumbs.forEach(function (thumb) {
        on(thumb, "click", function () { activateThumb(thumb); });
        on(thumb, "keydown", function (event) { optionKeys(event, thumbs, thumb, activateThumb); });
      });
      // Packaging is one optional variant dimension: none, gift box, or case.
      var initialAddon = selectedAddon();
      addons.forEach(function (addon) {
        addon.setAttribute("aria-checked", addon === initialAddon ? "true" : "false");
        addon.classList.toggle("is-active", addon === initialAddon);
        on(addon, "click", function () {
          var turnOn = addon.getAttribute("aria-checked") !== "true";
          addons.forEach(function (item) {
            var active = turnOn && item === addon;
            item.setAttribute("aria-checked", active ? "true" : "false");
            item.classList.toggle("is-active", active);
          });
          syncPurchase();
        });
      });
      function dispose() {
        if (disposed) return;
        disposed = true;
        cancelImages();
        cleanups.splice(0).forEach(function (cleanup) { cleanup(); });
        if (createdStatus && imageStatus) imageStatus.remove();
        if (chooser.__vpCastChooser === controller) delete chooser.__vpCastChooser;
      }
      var controller = { activate: activate, dispose: dispose };
      chooser.__vpCastChooser = controller;
      activate(activeChoice, false);
      return controller;
    }

    function setupCastChoosers() {
      var roots = [];
      queryActive("[data-cast-option]").forEach(function (option) {
        var chooser = option.closest("[data-cast-selector]") || option.closest("[data-world-panel]") || main;
        if (roots.indexOf(chooser) < 0) roots.push(chooser);
      });
      roots.forEach(function (chooser) {
        var controller = mountCastChooser(chooser);
        if (controller) dynamicCleanups.push(controller.dispose);
      });
    }

    function setupHomeHeroAndChapters() {
      queryActive("[data-home-hero]").forEach(function (hero) {
        var stage = hero.querySelector("[data-home-hero-stage]");
        if (!stage || reducedOrCoarse()) return;
        var tick = 0;
        var x = 0;
        var y = 0;
        function paint() {
          tick = 0;
          stage.style.setProperty("--hero-x", x.toFixed(2) + "px");
          stage.style.setProperty("--hero-y", y.toFixed(2) + "px");
        }
        function move(event) {
          if (event.pointerType && event.pointerType !== "mouse") return;
          var rect = stage.getBoundingClientRect();
          x = Math.max(-8, Math.min(8, ((event.clientX - rect.left) / rect.width - .5) * 16));
          y = Math.max(-7, Math.min(7, ((event.clientY - rect.top) / rect.height - .5) * 14));
          if (!tick) tick = window.requestAnimationFrame(paint);
        }
        function reset() { x = 0; y = 0; paint(); }
        listen(stage, "pointermove", move, { passive: true });
        listen(stage, "pointerleave", reset, { passive: true });
        dynamicCleanups.push(function () { if (tick) window.cancelAnimationFrame(tick); reset(); });
      });

    }

    function setupR9Finishes() {
      queryActive("[data-cast-selector]").forEach(function (chooser) {
        var finishes = [].slice.call(chooser.querySelectorAll("[data-finish-option]"));
        if (!finishes.length) return;
        var preview = chooser.querySelector("[data-finish-preview]");
        var gift = chooser.querySelector("[data-finish-gift]");
        var priceTarget = chooser.querySelector("[data-cast-price]:not([data-cast-option])");
        var linkTarget = chooser.querySelector("[data-cast-href]:not([data-cast-option])");
        var castOptions = [].slice.call(chooser.querySelectorAll("[data-cast-option]"));
        function activeCast() { return castOptions.filter(function (item) { return item.getAttribute("aria-pressed") === "true" || item.classList.contains("is-active"); })[0] || castOptions[0]; }
        function activate(finish, userInitiated) {
          var label = cleanText(finish.getAttribute("data-finish-label") || finish.textContent);
          var delta = parseFloat(finish.getAttribute("data-finish-delta")) || 0;
          var cast = activeCast();
          var raw = cleanText(cast ? cast.getAttribute("data-price") : "");
          var amount = parseFloat(raw.replace(/[^0-9.]/g, ""));
          finishes.forEach(function (item) { var active = item === finish; item.classList.toggle("is-active", active); item.setAttribute("aria-checked", active ? "true" : "false"); item.setAttribute("tabindex", active ? "0" : "-1"); });
          var vpFx = vpFxPrice(raw, delta);
          if (vpFx !== null) { if (priceTarget && /[0-9]/.test(raw)) priceTarget.textContent = vpFx; }
          else if (priceTarget && isFinite(amount)) priceTarget.textContent = "$" + (amount + delta) + (raw.indexOf("+") > -1 ? "+" : "");
          if (preview) preview.textContent = label === "Classic" ? T('js.app.finish_classic', "Classic display base included.") : label === "Gift ready" ? T('js.app.finish_gift', "Protective gift presentation added for the hand-off.") : T('js.app.finish_name', "A short name or date will be added to the display base.");
          if (gift) gift.hidden = label !== "Gift ready";
          if (linkTarget) {
            try {
              var originalHref = linkTarget.getAttribute("data-finish-base-href") || linkTarget.getAttribute("href");
              if (!linkTarget.hasAttribute("data-finish-base-href")) linkTarget.setAttribute("data-finish-base-href", originalHref);
              var url = new URL(originalHref, window.location.href);
              url.searchParams.set("finish", label.toLowerCase().replace(/\s+/g, "-"));
              linkTarget.setAttribute("href", url.pathname + url.search + url.hash);
            } catch (_) {}
          }
          if (userInitiated) announce(T('js.app.finish_selected', "{label} finish selected.").replace("{label}", function () { return label; }));
        }
        finishes.forEach(function (finish) {
          listen(finish, "click", function () { activate(finish, true); });
          listen(finish, "keydown", function (event) { optionKeys(event, finishes, finish, activate); });
        });
        listen(chooser, "vp:castchange", function () { activate(finishes.filter(function (item) { return item.getAttribute("aria-checked") === "true"; })[0] || finishes[0], false); });
        activate(finishes.filter(function (item) { return item.getAttribute("aria-checked") === "true"; })[0] || finishes[0], false);
      });
    }

    function setupOccasionDecks() {
      queryActive("[data-occasion-deck]").forEach(function (deck) {
        var tabs = [].slice.call(deck.querySelectorAll("[data-occasion-tab]"));
        var panels = [].slice.call(deck.querySelectorAll("[data-occasion-panel]"));
        if (!tabs.length || !panels.length) return;
        function activate(tab, userInitiated) {
          var panelId = tab.getAttribute("aria-controls");
          var panel = panelId ? doc.getElementById(panelId) : null;
          tabs.forEach(function (item) { var active = item === tab; item.setAttribute("aria-selected", active ? "true" : "false"); item.setAttribute("tabindex", active ? "0" : "-1"); });
          panels.forEach(function (item) { item.hidden = item !== panel; item.classList.remove("is-entering"); });
          if (panel && userInitiated && !motionQuery.matches) {
            panel.classList.add("is-entering");
            window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { panel.classList.remove("is-entering"); }); });
          }
          if (userInitiated) announce(cleanText(tab.textContent) + " story selected.");
        }
        tabs.forEach(function (tab) {
          listen(tab, "click", function () { activate(tab, true); });
          listen(tab, "keydown", function (event) { optionKeys(event, tabs, tab, activate); });
        });
        activate(tabs.filter(function (item) { return item.getAttribute("aria-selected") === "true"; })[0] || tabs[0], false);
      });
    }

    function setupDetailInspectors() {
      queryActive("[data-detail-map]").forEach(function (inspector) {
        var controls = [].slice.call(inspector.querySelectorAll("[data-detail-hotspot]"));
        var panels = [].slice.call(inspector.querySelectorAll("[data-detail-panel]"));
        function activate(control, userInitiated) {
          var panel = doc.getElementById(control.getAttribute("aria-controls") || "");
          controls.forEach(function (item) { item.setAttribute("aria-expanded", item === control ? "true" : "false"); });
          panels.forEach(function (item) { item.hidden = item !== panel; });
          if (userInitiated) announce(cleanText(control.textContent) + " detail selected.");
        }
        controls.forEach(function (control) {
          listen(control, "click", function () { activate(control, true); });
          listen(control, "focus", function () { activate(control, false); });
          listen(control, "pointerenter", function (event) { if (!event.pointerType || event.pointerType === "mouse") activate(control, false); }, { passive: true });
          listen(control, "keydown", function (event) { optionKeys(event, controls, control, activate); });
        });
        if (controls.length) activate(controls[0], false);
      });
    }

    function setupAboutWipes() {
      queryActive("[data-about-wipe]").forEach(function (wipe) {
        var input = wipe.querySelector('input[type="range"]');
        if (!input) return;
        function update() {
          var value = Math.max(0, Math.min(100, parseFloat(input.value) || 0));
          wipe.style.setProperty("--about-progress", value + "%");
          input.setAttribute("aria-valuetext", Math.round(value) + T('js.app.wipe_value_character', "% character, ") + Math.round(100 - value) + T('js.app.wipe_value_photo', "% photo"));
        }
        listen(input, "input", update);
        listen(input, "change", function () { announce(T('js.app.wipe_announce', "Photo to character comparison set to ") + input.value + T('js.app.wipe_announce_percent', " percent.")); });
        update();
      });
    }

    function setupProductStoryMotion() {
      queryActive("[data-product-story]").forEach(function (story) {
        var type = cleanText(story.getAttribute("data-product-story"));
        var media = story.querySelector("[data-story-media]");
        var steps = [].slice.call(story.querySelectorAll("[data-story-step]"));
        function activate(step, userInitiated) {
          var index = steps.indexOf(step);
          if (type === "3d-icon") {
            step.setAttribute("aria-pressed", step.getAttribute("aria-pressed") === "true" ? "false" : "true");
            story.classList.toggle("is-kit-complete", steps.every(function (item) { return item.getAttribute("aria-pressed") === "true"; }));
          } else {
            steps.forEach(function (item) { item.setAttribute("aria-pressed", item === step ? "true" : "false"); });
          }
          story.setAttribute("data-active-story-step", String(index + 1));
          if (media) {
            if (type === "brick-solo") {
              var solo = [["0%", "8%", 1.09], ["0%", "0%", 1.06], ["0%", "-7%", 1.08]][index] || ["0%", "0%", 1];
              media.style.setProperty("--story-x", solo[0]); media.style.setProperty("--story-y", solo[1]); media.style.setProperty("--story-scale", solo[2]);
            } else if (type === "3d-soft-solo") {
              story.style.setProperty("--story-compare", [28, 56, 82][index] + "%");
            } else if (type === "3d-duo") {
              media.style.setProperty("--story-rotate", [-3, 0, 3][index] + "deg");
            } else if (type === "3d-crew") {
              var crew = [["4%", "2%", 1.08], ["0%", "-2%", 1.05], ["-4%", "1%", 1.08]][index] || ["0%", "0%", 1];
              media.style.setProperty("--story-x", crew[0]); media.style.setProperty("--story-y", crew[1]); media.style.setProperty("--story-scale", crew[2]);
            }
          }
          if (userInitiated) announce(cleanText(step.textContent) + " detail selected.");
        }
        steps.forEach(function (step) {
          listen(step, "click", function () { activate(step, true); });
          listen(step, "keydown", function (event) { optionKeys(event, steps, step, activate); });
        });
        if (steps.length && type !== "3d-icon") activate(steps.filter(function (item) { return item.getAttribute("aria-pressed") === "true"; })[0] || steps[0], false);

        if (media && type === "3d-duo" && !reducedOrCoarse()) {
          listen(media, "pointermove", function (event) { var rect = media.getBoundingClientRect(); media.style.setProperty("--story-rotate", ((((event.clientX - rect.left) / rect.width) - .5) * 8).toFixed(2) + "deg"); }, { passive: true });
          listen(media, "pointerleave", function () { media.style.setProperty("--story-rotate", "0deg"); }, { passive: true });
        }
        if (media && type === "3d-pet") {
          media.setAttribute("tabindex", "0");
          media.setAttribute("role", "button");
          media.setAttribute("aria-label", "Hold to inspect the pet silhouette");
          function inspect(active) { story.classList.toggle("is-inspecting", active); media.setAttribute("aria-pressed", active ? "true" : "false"); }
          listen(media, "pointerdown", function () { inspect(true); });
          listen(media, "pointerup", function () { inspect(false); });
          listen(media, "pointercancel", function () { inspect(false); });
          listen(media, "pointerleave", function () { inspect(false); });
          listen(media, "keydown", function (event) { if (event.key === " " || event.key === "Enter") { event.preventDefault(); inspect(true); } });
          listen(media, "keyup", function (event) { if (event.key === " " || event.key === "Enter") inspect(false); });
        }
        if (type === "brick-heritage") {
          var ledger = [].slice.call(story.querySelectorAll("dl > div"));
          var caption = story.querySelector("[data-story-caption]");
          ledger.forEach(function (item) {
            item.setAttribute("tabindex", "0"); item.setAttribute("role", "button");
            function select() { ledger.forEach(function (entry) { entry.classList.toggle("is-active", entry === item); }); if (caption) caption.textContent = cleanText(item.textContent); }
            listen(item, "click", select); listen(item, "keydown", function (event) { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); select(); } });
          });
        }
      });
    }

    function closestViewportStep(steps) {
      var target = window.innerHeight * .54;
      var best = 0;
      var distance = Infinity;
      steps.forEach(function (step, index) {
        var rect = step.getBoundingClientRect();
        var current = Math.abs(rect.top + rect.height * .5 - target);
        if (current < distance) { distance = current; best = index; }
      });
      return best;
    }

    function setupStepTracker(board, steps, progress, type) {
      if (!steps.length) return;
      var activeIndex = -1;
      var tick = 0;
      function activate(index) {
        index = Math.max(0, Math.min(steps.length - 1, index));
        if (index === activeIndex) return;
        activeIndex = index;
        var percent = type === "material" && steps.length > 1 ? (index / (steps.length - 1)) * 100 : ((index + 1) / steps.length) * 100;
        board.setAttribute("data-active-step", String(index + 1));
        board.style.setProperty("--" + type + "-progress", percent.toFixed(2) + "%");
        steps.forEach(function (step, stepIndex) {
          var active = stepIndex === index;
          step.classList.toggle("is-active", active);
          if (active) step.setAttribute("aria-current", "step");
          else step.removeAttribute("aria-current");
        });
        if (progress) {
          progress.style.setProperty("--progress", percent.toFixed(2) + "%");
          if (progress.tagName === "PROGRESS") { progress.max = steps.length; progress.value = index + 1; }
          else {
            if (!progress.closest('[aria-hidden="true"]')) {
              progress.setAttribute("role", "progressbar");
              progress.setAttribute("aria-valuemin", "1");
              progress.setAttribute("aria-valuemax", String(steps.length));
              progress.setAttribute("aria-valuenow", String(index + 1));
            }
            if (progress.hasAttribute("data-process-progress")) progress.textContent = String(index + 1).padStart(2, "0") + " / " + String(steps.length).padStart(2, "0");
            else if (!progress.children.length && /^\d+$/.test(cleanText(progress.textContent))) progress.textContent = String(index + 1).padStart(2, "0");
          }
        }
      }
      function update() {
        tick = 0;
        var rect = board.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        activate(closestViewportStep(steps));
      }
      function requestUpdate() { if (!tick) tick = window.requestAnimationFrame(update); }
      steps.forEach(function (step, index) {
        listen(step, "focusin", function () { activate(index); });
        listen(step, "pointerenter", function (event) { if (!event.pointerType || event.pointerType === "mouse") activate(index); }, { passive: true });
      });
      activate(0);
      if (!motionQuery.matches && (type !== "material" || !coarseQuery.matches)) {
        listen(window, "scroll", requestUpdate, { passive: true });
        listen(window, "resize", requestUpdate, { passive: true });
        update();
      }
    }

    function setupProcessBoards() {
      var boards = queryActive("[data-process-board], .steps--editorial, .proof-journey");
      boards.forEach(function (board) {
        if (board.closest("[data-process-board]") && board.closest("[data-process-board]") !== board) return;
        if (!board.hasAttribute("data-process-board")) board.setAttribute("data-process-board", "");
        var steps = queryActive("[data-process-step], .step, .proof-journey__steps > li", board);
        steps.forEach(function (step) { if (!step.hasAttribute("data-process-step")) step.setAttribute("data-process-step", ""); });
        var progress = queryActive("[data-process-progress]", board)[0] || null;
        setupStepTracker(board, steps, progress, "process");
      });
    }

    function setupMaterialStories() {
      queryActive("[data-material-story], .material-story").forEach(function (story) {
        if (!story.hasAttribute("data-material-story")) story.setAttribute("data-material-story", "");
        var steps = queryActive("[data-material-step], .material-story__list li, .material-story__copy ul li", story);
        steps.forEach(function (step) { if (!step.hasAttribute("data-material-step")) step.setAttribute("data-material-step", ""); });
        setupStepTracker(story, steps, queryActive("[data-material-progress]", story)[0] || null, "material");
      });
    }

    function setupFaqFiltering() {
      var faq = queryActive("[data-faq-root], .faq")[0] || null;
      if (!faq) return;
      var search = faq.querySelector("[data-faq-search]");
      var heroSearch = doc.getElementById("faqHeroSearch");
      var searchInputs = [heroSearch, search].filter(function (input, index, inputs) { return input && inputs.indexOf(input) === index; });
      var filters = [].slice.call(faq.querySelectorAll("[data-faq-filter]"));
      if (!searchInputs.length && !filters.length) return;
      var groupElements = [].slice.call(faq.querySelectorAll("[data-faq-group]"));
      var groups = [];
      groupElements.forEach(function (element) {
        var details = element.matches("details") ? [element] : [].slice.call(element.querySelectorAll("details"));
        if (details.length) groups.push({ element: element, heading: element.querySelector(".faq__group"), details: details, key: cleanText(element.getAttribute("data-faq-group")).toLowerCase() });
      });
      if (!groups.length) {
        [].slice.call(faq.querySelectorAll(".faq__list")).forEach(function (list) {
          var heading = list.previousElementSibling && list.previousElementSibling.classList.contains("faq__group") ? list.previousElementSibling : null;
          groups.push({ element: list, heading: heading, details: [].slice.call(list.querySelectorAll("details")), key: cleanText(heading ? heading.textContent : "all").toLowerCase().replace(/[^a-z0-9]+/g, "-") });
        });
      }
      var statusNode = faq.querySelector("[data-faq-results]");
      var emptyNode = faq.querySelector("[data-faq-empty]");
      if (!statusNode && search) {
        statusNode = doc.createElement("p");
        statusNode.className = "faq__results";
        statusNode.setAttribute("data-faq-results", "");
        (search.closest(".faq__search") || search).insertAdjacentElement("afterend", statusNode);
      }
      if (statusNode) { statusNode.setAttribute("role", "status"); statusNode.setAttribute("aria-live", "polite"); }
      var selectedGroup = "all";
      var searchValue = heroSearch && heroSearch.value ? heroSearch.value : search ? search.value : "";

      // Both layouts share one query. Do not dispatch synthetic input events:
      // direct synchronisation avoids cycles and survives hiding the second field.
      function setSearchValue(value) {
        searchValue = value;
        searchInputs.forEach(function (input) { if (input.value !== value) input.value = value; });
      }

      function resetFilters() {
        selectedGroup = "all";
        filters.forEach(function (filter) {
          var active = (cleanText(filter.getAttribute("data-faq-filter")).toLowerCase() || "all") === "all";
          filter.classList.toggle("is-active", active);
          filter.setAttribute("aria-pressed", active ? "true" : "false");
        });
      }

      function focusTarget(target) {
        if (!target) return;
        if (target.tagName !== "SUMMARY" && !target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
        try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
        window.scrollTo({
          top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - 92),
          behavior: motionQuery.matches ? "auto" : "smooth"
        });
      }

      function searchableFaqText(detail) {
        var copy = detail.cloneNode(true);
        [].slice.call(copy.querySelectorAll("[data-world-only]")).forEach(function (worldCopy) {
          if (worldCopy.getAttribute("data-world-only") !== state.world) worldCopy.remove();
        });
        return cleanText(copy.textContent).toLowerCase();
      }

      function apply() {
        var term = cleanText(searchValue).toLowerCase();
        var visibleCount = 0;
        var firstVisible = null;
        groups.forEach(function (group) {
          var groupAllowed = selectedGroup === "all" || group.key.split(/[\s,|]+/).indexOf(selectedGroup) !== -1;
          var groupText = cleanText((group.heading ? group.heading.textContent : "") + " " + group.key).toLowerCase();
          var groupCount = 0;
          group.details.forEach(function (detail) {
            var matches = groupAllowed && (!term || searchableFaqText(detail).indexOf(term) !== -1 || groupText.indexOf(term) !== -1);
            detail.hidden = !matches;
            detail.setAttribute("aria-hidden", matches ? "false" : "true");
            if (matches) { groupCount += 1; visibleCount += 1; if (!firstVisible) firstVisible = detail; }
          });
          group.element.hidden = groupCount === 0;
          if (group.heading && group.heading !== group.element) group.heading.hidden = groupCount === 0;
        });
        faq.classList.toggle("has-no-results", visibleCount === 0);
        if (statusNode) statusNode.textContent = visibleCount ? visibleCount + (visibleCount === 1 ? T('js.app.faq_count_one', " answer found") : T('js.app.faq_count_many', " answers found")) : T('js.app.faq_none', "No answers found. Try a different word.");
        if (emptyNode) emptyNode.hidden = visibleCount !== 0;
        if (term && firstVisible) {
          groups.forEach(function (group) {
            group.details.forEach(function (detail) { detail.open = detail === firstVisible; });
          });
        }
        refreshRevealItems();
        return firstVisible;
      }

      searchInputs.forEach(function (input) {
        input.setAttribute("type", "search");
        input.setAttribute("autocomplete", "off");
        listen(input, "input", function () { setSearchValue(input.value); apply(); });
        listen(input, "keydown", function (event) {
          // The sidebar is not a form. Give Enter the same result-navigation
          // behavior as the hero's submit without firing the hero twice.
          if (event.key === "Enter" && input !== heroSearch && !event.isComposing) {
            event.preventDefault();
            setSearchValue(input.value);
            var firstVisible = apply();
            focusTarget(firstVisible ? firstVisible.querySelector("summary") || firstVisible : emptyNode || statusNode || faq);
            return;
          }
          if (event.key !== "Escape" || (!searchValue && selectedGroup === "all")) return;
          event.preventDefault();
          setSearchValue("");
          resetFilters();
          apply();
        });
      });
      if (heroSearch && heroSearch.form) {
        listen(heroSearch.form, "submit", function (event) {
          event.preventDefault();
          setSearchValue(heroSearch.value);
          var firstVisible = apply();
          focusTarget(firstVisible ? firstVisible.querySelector("summary") || firstVisible : emptyNode || statusNode || faq);
        });
      }
      filters.forEach(function (filter) {
        listen(filter, "click", function (event) {
          if (filter.tagName === "A") event.preventDefault();
          selectedGroup = cleanText(filter.getAttribute("data-faq-filter")).toLowerCase() || "all";
          filters.forEach(function (item) { var active = item === filter; item.classList.toggle("is-active", active); item.setAttribute("aria-pressed", active ? "true" : "false"); });
          apply();
        });
      });
      [].slice.call(doc.querySelectorAll('.inner-r18__faq-chips a[href^="#"], .inner-r14__faq-nav nav a[href^="#"]')).forEach(function (link) {
        var hash = link.getAttribute("href"), id;
        try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
        var targetGroup = groups.filter(function (group) {
          return group.element.getAttribute("id") === id || (group.heading && group.heading.getAttribute("id") === id);
        })[0];
        if (!targetGroup) return;
        listen(link, "click", function (event) {
          // Preserve native modified-click navigation and unrelated hash links.
          if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button != null && event.button !== 0)) return;
          event.preventDefault();
          setSearchValue("");
          resetFilters();
          apply();
          if (window.history && window.history.pushState && window.location.hash !== hash) {
            try { window.history.pushState(window.history.state, "", hash); } catch (_) { /* Restricted History must not block the visible topic or focus. */ }
          }
          focusTarget(targetGroup.heading || targetGroup.element);
        });
      });
      var clear = faq.querySelector("[data-faq-clear]");
      if (clear && searchInputs.length) listen(clear, "click", function (event) {
        event.preventDefault();
        setSearchValue("");
        resetFilters();
        apply();
        var visibleInput = searchInputs.filter(function (input) { return input.getClientRects().length; })[0];
        if (visibleInput) visibleInput.focus();
      });
      setSearchValue(searchValue);
      apply();
    }

    function setupContactForms() {
      queryActive("form.cform").forEach(function (form) {
        if (form.hasAttribute("data-contact-truth")) return;
        var summary = doc.querySelector("[data-contact-summary]");
        if (summary && !belongsToActiveWorld(summary)) summary = null;
        var statusNode = form.querySelector("[data-contact-status], .cform__status");
        if (!statusNode) {
          statusNode = doc.createElement("p");
          statusNode.className = "cform__status";
          statusNode.setAttribute("data-contact-status", "");
          var submit = form.querySelector('[type="submit"]');
          if (submit) submit.insertAdjacentElement("afterend", statusNode);
          else form.appendChild(statusNode);
        }
        statusNode.setAttribute("role", "status");
        statusNode.setAttribute("aria-live", "polite");
        statusNode.setAttribute("aria-atomic", "true");

        function fieldValue(name) {
          var field = form.elements[name];
          if (!field) return "";
          if (field.options && field.selectedIndex >= 0) return cleanText(field.options[field.selectedIndex].textContent);
          return cleanText(field.value);
        }

        function updateSummary() {
          if (!summary) return;
          var values = {
            world: fieldValue("world") || worldName(state.world),
            name: fieldValue("name") || "Your name",
            email: fieldValue("email") || "Your email",
            message: fieldValue("message") || "Tell us who you would like to make",
            cast: fieldValue("cast") || "One person",
            occasion: fieldValue("occasion") || "Just because"
          };
          var targets = summary.querySelectorAll("[data-contact-summary-field], [data-contact-summary-world], [data-contact-summary-name], [data-contact-summary-email], [data-contact-summary-message], [data-contact-summary-cast], [data-contact-summary-occasion], [data-contact-world], [data-contact-name], [data-contact-email], [data-contact-message], [data-contact-cast], [data-contact-occasion]");
          if (!targets.length) summary.textContent = values.world + " · " + values.name + " · " + values.cast + " · " + values.occasion;
          else [].forEach.call(targets, function (target) {
            var key = target.getAttribute("data-contact-summary-field");
            if (!key) {
              ["world", "name", "email", "message", "cast", "occasion"].some(function (candidate) {
                if (target.hasAttribute("data-contact-summary-" + candidate) || target.hasAttribute("data-contact-" + candidate)) { key = candidate; return true; }
                return false;
              });
            }
            if (key && values[key] !== undefined) target.textContent = values[key];
          });
          var requiredSignals = [fieldValue("name"), fieldValue("email"), fieldValue("cast"), fieldValue("occasion")];
          var fileInput = form.querySelector('input[type="file"]');
          if (fileInput) requiredSignals.push(fileInput.files && fileInput.files.length ? "file" : "");
          var completed = requiredSignals.filter(function (value) { return !!cleanText(value); }).length;
          var percent = requiredSignals.length ? Math.round((completed / requiredSignals.length) * 100) : 0;
          var completion = summary.querySelector("[data-contact-completion]");
          summary.style.setProperty("--completion", percent + "%");
          if (completion) completion.textContent = percent + "% ready";
          if (percent < 100) summary.removeAttribute("data-contact-state");
        }

        var contactButton = form.querySelector('[type="submit"]');
        // World/motion refreshes reuse this button after preview changes its
        // text. Keep the authored action label rather than caching that state.
        if (contactButton && typeof contactButton.__vpContactIdleLabel !== "string") contactButton.__vpContactIdleLabel = contactButton.textContent;
        var contactButtonLabel = contactButton ? contactButton.__vpContactIdleLabel : "";
        var contactInvalidMessage = T('js.app.contact_invalid', "Please complete the highlighted required fields.");
        function editContact() {
          if (form.classList.contains("is-sent") && form.getAttribute("data-contact-mode") !== "shopify") {
            form.classList.remove("is-sent");
            statusNode.textContent = "";
            if (contactButton) { contactButton.disabled = false; contactButton.textContent = contactButtonLabel; }
          }
          // Reading :invalid does not emit invalid events or move focus as
          // checkValidity/reportValidity would. Never erase server feedback.
          if (form.classList.contains("has-errors") && statusNode.textContent === contactInvalidMessage && !form.querySelector(":invalid")) {
            form.classList.remove("has-errors");
            statusNode.textContent = "";
          }
          updateSummary();
        }
        listen(form, "input", editContact);
        listen(form, "change", editContact);
        listen(form, "reset", function () { if (summary) summary.removeAttribute("data-contact-state"); window.setTimeout(editContact, 0); });
        listen(form, "invalid", function () {
          form.classList.add("has-errors");
          statusNode.textContent = contactInvalidMessage;
        }, true);
        listen(form, "submit", function (event) {
          // Converted Shopify contact forms submit natively (including any
          // platform challenge). Local previews never claim delivery.
          if (form.getAttribute("data-contact-mode") === "shopify") return;
          event.preventDefault();
          if (!form.checkValidity()) { form.classList.add("has-errors"); statusNode.textContent = contactInvalidMessage; form.reportValidity(); return; }
          form.classList.remove("has-errors");
          form.classList.add("is-sent");
          var button = form.querySelector('[type="submit"]');
          if (button) { button.textContent = "Message ready"; button.disabled = true; }
          statusNode.textContent = "Thanks — your enquiry is ready. Store submission will be connected separately.";
          if (summary) summary.setAttribute("data-contact-state", "ready");
          announce("Message form is ready. Store submission will be connected separately.");
          updateSummary();
        });
        updateSummary();
      });
    }

    function refresh() {
      clearDynamic();
      setMotionMode();
      setupCompactNav();
      setupReveals();
      setupTilts();
      setupMagneticActions();
      setupGalleryFilters();
      setupFilmstrips();
      setupUploadDropzones();
      setupStepChapters();
      setupCastChoosers();
      setupHomeHeroAndChapters();
      setupR9Finishes();
      setupOccasionDecks();
      setupDetailInspectors();
      setupAboutWipes();
      setupProductStoryMotion();
      setupProcessBoards();
      setupMaterialStories();
      setupFaqFiltering();
      setupContactForms();
    }

    function init() {
      if (initialized) return;
      initialized = true;
      window.addEventListener("vp:worldchange", refresh);
      var preferenceChanged = function () { refresh(); };
      if (motionQuery.addEventListener) motionQuery.addEventListener("change", preferenceChanged);
      else if (motionQuery.addListener) motionQuery.addListener(preferenceChanged);
      if (coarseQuery.addEventListener) coarseQuery.addEventListener("change", preferenceChanged);
      else if (coarseQuery.addListener) coarseQuery.addListener(preferenceChanged);
      refresh();
    }

    return { init: init, refresh: refresh, refreshReveals: refreshRevealItems };
  })();

  commitWorld(state.world, { restore: false, persist: !gatewayPending(), updateUrl: !gatewayPending() });
  initGateway();
  if (!gatewayPending() && !consumeHandoff()) {
    clearPortalVisuals();
    setInteractiveLock(false);
  } else if (gatewayPending()) {
    clearPortalVisuals();
    setInteractiveLock(false);
  }
  motionController.init();
  body.classList.add("is-ready");
})();

/* ==========================================================================
   VP-CHAT — 客服入口交互
   站内 UI 完全自控（本地可测、配色统一）；点「Chat with us」时优先唤起
   Shopify Inbox 的真人对话，未装/未加载则降级为邮件。
   ========================================================================== */
(function () {
  "use strict";

  var root = document.querySelector("[data-vp-chat]");
  if (!root) return;

  var toggle = root.querySelector("[data-vp-chat-toggle]");
  var panel = root.querySelector("#vpChatPanel");
  var closeBtn = root.querySelector("[data-vp-chat-close]");
  var startBtn = root.querySelector("[data-vp-chat-start]");
  var status = root.querySelector("[data-vp-chat-status]");
  if (!toggle || !panel) return;

  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", String(open));
    root.setAttribute("data-open", String(open));
    if (open) {
      var first = panel.querySelector(".vp-chat__q");
      if (first) first.focus({ preventScroll: true });
    }
  }

  toggle.addEventListener("click", function () {
    setOpen(panel.hidden);
  });
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      setOpen(false);
      toggle.focus({ preventScroll: true });
    });
  }

  // Esc 关闭；点击面板外关闭
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) {
      setOpen(false);
      toggle.focus({ preventScroll: true });
    }
  });
  document.addEventListener("click", function (e) {
    if (!panel.hidden && !root.contains(e.target)) setOpen(false);
  });

  // FAQ 手风琴：一次只展开一条
  root.querySelectorAll(".vp-chat__q").forEach(function (q) {
    q.addEventListener("click", function () {
      var answer = document.getElementById(q.getAttribute("aria-controls"));
      var willOpen = q.getAttribute("aria-expanded") !== "true";
      root.querySelectorAll(".vp-chat__q").forEach(function (other) {
        other.setAttribute("aria-expanded", "false");
        var a = document.getElementById(other.getAttribute("aria-controls"));
        if (a) a.hidden = true;
      });
      q.setAttribute("aria-expanded", String(willOpen));
      if (answer) answer.hidden = !willOpen;
    });
  });

  // ---- Shopify Inbox 对接 ----
  // Inbox 以自定义元素 / iframe 注入，不同版本容器名不同，逐个尝试。
  function findInbox() {
    return document.querySelector(
      "shopify-chat, #ShopifyChat, [id^='ShopifyChat'], .shopify-chat-container"
    );
  }

  function openInbox() {
    var host = findInbox();
    if (!host) return false;
    // 优先点它 shadow DOM 里的启动按钮
    var target = null;
    if (host.shadowRoot) target = host.shadowRoot.querySelector("button, [role='button']");
    if (!target) target = host.querySelector && host.querySelector("button, [role='button']");
    if (target && typeof target.click === "function") { target.click(); return true; }
    if (typeof host.click === "function") { host.click(); return true; }
    return false;
  }

  if (startBtn) {
    startBtn.addEventListener("click", function () {
      if (openInbox()) {
        setOpen(false);
        return;
      }
      // 未接入 Inbox（如本地预览）：降级到邮件，并说明原因
      if (status) status.textContent = "Live chat loads on the store — opening email instead";
      window.location.href = "mailto:hello@voxelpals.com?subject=" + encodeURIComponent("Question about my custom figure");
    });
  }

  // Inbox 就绪后隐藏它自带的浮标，避免和我们的入口重复
  function hideNativeLauncher() {
    var host = findInbox();
    if (!host) return false;
    host.style.setProperty("opacity", "0", "important");
    host.style.setProperty("pointer-events", "none", "important");
    host.style.setProperty("visibility", "hidden", "important");
    return true;
  }
  if (!hideNativeLauncher()) {
    var observer = new MutationObserver(function () {
      if (hideNativeLauncher()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }
})();

/* ==========================================================================
   VP-HERO-CAROUSEL — banner 轮播交互
   自动播放 / 圆点 / 箭头 / 键盘 / 触摸滑动；悬停与后台标签暂停
   ========================================================================== */
(function () {
  "use strict";

  var AUTOPLAY_MS = 6000;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-hero-carousel]").forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll("[data-hero-slide]"));
    var dots = [].slice.call(root.querySelectorAll("[data-hero-dot]"));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var hovering = false;
    var inView = false;
    var worldPanel = root.closest("[data-world-panel]");
    var motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");

    function canAutoplay() {
      var page = document.documentElement;
      return !motionPreference.matches && !document.hidden && inView && !hovering &&
        page.dataset.entry !== "gateway" && !page.classList.contains("is-world-transitioning") &&
        (!worldPanel || (!worldPanel.hidden && worldPanel.dataset.worldPanel === page.dataset.world));
    }

    function show(next) {
      next = (next + slides.length) % slides.length;
      if (next === index) return;
      slides[index].classList.remove("is-active");
      slides[index].setAttribute("aria-hidden", "true");
      slides[next].classList.add("is-active");
      slides[next].setAttribute("aria-hidden", "false");
      if (dots[index]) { dots[index].classList.remove("is-active"); dots[index].setAttribute("aria-current", "false"); }
      if (dots[next]) { dots[next].classList.add("is-active"); dots[next].setAttribute("aria-current", "true"); }
      index = next;
    }

    function start() {
      if (timer || !canAutoplay()) return;
      timer = window.setInterval(function () {
        if (!canAutoplay()) { stop(); return; }
        show(index + 1);
      }, AUTOPLAY_MS);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { show(i); restart(); });
    });
    var prev = root.querySelector("[data-hero-prev]");
    var next = root.querySelector("[data-hero-next]");
    if (prev) prev.addEventListener("click", function () { show(index - 1); restart(); });
    if (next) next.addEventListener("click", function () { show(index + 1); restart(); });

    // 悬停暂停，避免读文案时被切走
    root.addEventListener("mouseenter", function () { hovering = true; stop(); });
    root.addEventListener("mouseleave", function () { hovering = false; start(); });
    root.addEventListener("focusin", function () { hovering = true; stop(); });
    root.addEventListener("focusout", function () {
      if (!root.contains(document.activeElement)) { hovering = false; start(); }
    });

    // 键盘左右切换
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { show(index - 1); restart(); }
      else if (e.key === "ArrowRight") { show(index + 1); restart(); }
    });

    // 触摸滑动
    var touchX = null;
    root.addEventListener("touchstart", function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 46) { show(index + (dx < 0 ? 1 : -1)); restart(); }
      touchX = null;
    }, { passive: true });

    // 标签页不可见时不空转
    document.addEventListener("visibilitychange", function () {
      if (canAutoplay()) start(); else stop();
    });
    function reevaluate() { if (canAutoplay()) start(); else stop(); }
    ["vp:worldchange", "vp:entryready", "vp:transitionstart", "vp:transitionend", "pageshow"].forEach(function (eventName) {
      window.addEventListener(eventName, reevaluate);
    });
    if (motionPreference.addEventListener) motionPreference.addEventListener("change", reevaluate);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        reevaluate();
      }, { threshold: .1 }).observe(root);
    } else { inView = true; start(); }
    window.addEventListener("pagehide", stop);
  });
})();

/* ==========================================================================
   VP-PDP — 产品详情页：包装切换改价、照片校验、下单提交
   目前站点是静态版，提交先落到 Shopify 的 /cart/add 约定字段；
   未接通时降级为把定制信息带到定制申请页，避免用户填完无处可去。
   ========================================================================== */
(function () {
  "use strict";

  var form = document.querySelector("[data-pdp-form]");
  if (!form || form.hasAttribute("data-request-url")) return;

  var priceNodes = form.querySelectorAll("[data-pdp-price]");
  var packs = form.querySelectorAll('input[name="pack"]');
  var photo = form.querySelector("[data-pdp-photo]");

  function currentPack() {
    for (var i = 0; i < packs.length; i++) if (packs[i].checked) return packs[i];
    return packs[0];
  }

  function syncPrice() {
    var p = currentPack();
    if (!p) return;
    if (window.VP_MONEY) return;
    var txt = "$" + p.getAttribute("data-price");
    for (var i = 0; i < priceNodes.length; i++) priceNodes[i].textContent = txt;
  }

  // 变体带专属主图时（如画框黑/白两色）跟着切换，避免选中项与图片不一致
  var hero = document.querySelector("[data-pdp-hero]");
  function syncHero() {
    var p = currentPack();
    if (!hero || !p) return;
    var src = p.getAttribute("data-img");
    if (src && hero.getAttribute("src") !== src) hero.setAttribute("src", src);
  }

  for (var i = 0; i < packs.length; i++) {
    packs[i].addEventListener("change", syncPrice);
    packs[i].addEventListener("change", syncHero);
  }
  syncPrice();
  syncHero();

  // 照片体积校验：定制品最怕收到糊图
  if (photo) {
    photo.addEventListener("change", function () {
      var f = photo.files && photo.files[0];
      var hint = photo.parentNode.querySelector("i");
      if (!f || !hint) return;
      var mb = f.size / 1048576;
      if (mb > 12) {
        hint.textContent = "That file is " + mb.toFixed(1) + "MB — please send one under 12MB.";
        hint.style.color = "#e50044";
        photo.value = "";
      } else {
        hint.textContent = f.name + " · " + mb.toFixed(1) + "MB — looks good.";
        hint.style.color = "";
      }
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var pack = currentPack();
    var data = {
      handle: form.getAttribute("data-handle"),
      pack: pack ? pack.value : "",
      price: pack ? pack.getAttribute("data-price") : form.getAttribute("data-base"),
      engraving: (form.querySelector('[name="engraving"]') || {}).value || "",
      notes: (form.querySelector('[name="notes"]') || {}).value || ""
    };

    // 接通 Shopify 后走真实加购；此处保留挂载点
    if (window.VP_CART && typeof window.VP_CART.add === "function") {
      window.VP_CART.add(data, photo && photo.files[0]);
      return;
    }

    try { sessionStorage.setItem("vp_pending_order", JSON.stringify(data)); } catch (err) {}
    var q = "?product=" + encodeURIComponent(data.handle) +
            "&pack=" + encodeURIComponent(data.pack) +
            "&price=" + encodeURIComponent(data.price);
    window.location.href = "custom-request.html" + q;
  });
})();

/* 定制申请页：带入从产品页传来的选择 */
(function () {
  "use strict";
  var f = document.querySelector("[data-custom-request]");
  if (!f || f.querySelector("[data-request-selection]")) return;
  var q = new URLSearchParams(window.location.search);
  var product = q.get("product");
  if (!product) return;
  var brief = f.querySelector('[name="brief"]');
  if (brief && !brief.value) {
    brief.value = "I was looking at: " + product +
      (q.get("pack") ? " (" + q.get("pack") + ")" : "") +
      (q.get("price") ? " — $" + q.get("price") : "") + "\n\n";
    brief.focus();
    brief.setSelectionRange(brief.value.length, brief.value.length);
  }
})();

/* Comparison images must not start the browser's native image drag. */
(function () {
  "use strict";
  document.querySelectorAll(".ba img").forEach(function (img) {
    img.setAttribute("draggable", "false");
    img.addEventListener("dragstart", function (e) { e.preventDefault(); });
  });
})();

/* 购物车角标：全页缓存下 section 渲染的数量会发馊，统一由前端回填 */
(function () {
  "use strict";
  var links = document.querySelectorAll(".hdr-cart");
  if (!links.length || !window.Shopify || !window.Shopify.routes) return;
  fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      links.forEach(function (link) {
        var badge = link.querySelector(".hdr-cart__count");
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "hdr-cart__count";
          link.appendChild(badge);
        }
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
        var label = T('js.app.cart_aria', "Cart") + (cart.item_count ? ", " + cart.item_count + (cart.item_count === 1 ? T('js.app.cart_aria_items_one', " items") : T('js.app.cart_aria_items', " items")) : "");
        link.setAttribute("aria-label", label);
      });
    })
    .catch(function () {});
})();

/* Health audit 2026-09-20: invalid events precede native submit events. */
(function mountNativeValidationHelp() {
  "use strict";
  var pendingField = null;
  var validationPass = 0;

  function prelaunchError(field, invalid) {
    var form = field && field.form;
    if (!form || !form.hasAttribute("data-prelaunch-form") || field.type !== "email") return;
    var error = form.querySelector("[data-prelaunch-error]");
    if (!error) return;
    if (invalid) {
      if (!error.id) error.id = "vpPrelaunchEmailError";
      error.textContent = T('js.app.email_invalid', "Please enter a valid email address.");
      error.hidden = false;
      error.setAttribute("role", "alert");
      field.setAttribute("aria-invalid", "true");
      field.setAttribute("data-vp-inline-invalid", "true");
      var descriptions = (field.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
      if (descriptions.indexOf(error.id) === -1) descriptions.push(error.id);
      field.setAttribute("aria-describedby", descriptions.join(" "));
    } else if (field.hasAttribute("data-vp-inline-invalid")) {
      error.textContent = "";
      error.hidden = true;
      field.removeAttribute("aria-invalid");
      field.removeAttribute("data-vp-inline-invalid");
      var remaining = (field.getAttribute("aria-describedby") || "").split(/\s+/).filter(function (id) { return id && id !== error.id; });
      if (remaining.length) field.setAttribute("aria-describedby", remaining.join(" "));
      else field.removeAttribute("aria-describedby");
    }
  }

  document.addEventListener("invalid", function (event) {
    var field = event.target;
    prelaunchError(field, true);
    // Let native validation and each form's own error UI run. A modal has its
    // own scroll area; hidden file inputs are handled by their upload control.
    if (!field || !field.form || !field.getBoundingClientRect ||
        field.closest('[hidden], [inert], [role="dialog"], [aria-modal="true"]')) return;
    var rect = field.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2 || pendingField) return;
    pendingField = field;
    var pass = ++validationPass;
    window.setTimeout(function () {
      var target = pendingField;
      pendingField = null;
      function revealField() {
        if (pass !== validationPass || !target || !target.isConnected ||
            document.activeElement !== target || (target.validity && target.validity.valid)) return;
        var header = document.getElementById("nav");
        if (!header) return;
        var position = window.getComputedStyle(header).position;
        if (position !== "fixed" && position !== "sticky") return;
        var bottom = header.getBoundingClientRect().bottom;
        var targetRect = target.getBoundingClientRect();
        if (targetRect.width < 2 || targetRect.height < 2) return;
        var top = targetRect.top;
        var label = target.labels && target.labels[0];
        if (label) {
          var labelRect = label.getBoundingClientRect();
          if (labelRect.width >= 2 && labelRect.height >= 2) top = Math.min(top, labelRect.top);
        }
        if (bottom > 0 && top < bottom + 20) {
          window.scrollBy({ top: top - bottom - 20, left: 0, behavior: "instant" });
        }
      }
      // Native focus can scroll after invalid dispatch; the compact header also
      // settles on a later frame. Recheck briefly without stealing changed focus.
      revealField();
      window.setTimeout(revealField, 100);
      window.setTimeout(revealField, 300);
    }, 0);
  }, true);

  document.addEventListener("input", function (event) {
    var field = event.target;
    if (field && field.validity && field.validity.valid) prelaunchError(field, false);
  });
  document.addEventListener("reset", function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute("data-prelaunch-form")) return;
    prelaunchError(form.querySelector('input[type="email"]'), false);
  }, true);
})();


/* Shared, themed back-to-top control. Uses the existing occasion artwork. */
(function () {
  'use strict';
  if (document.querySelector('[data-vp-back-top]')) return;
  var occasion = document.querySelector('[data-occasion]');
  var theme = occasion ? occasion.getAttribute('data-occasion') : 'default';
  var motifs = {
    wedding:'seedling', anniversary:'ring', christmas:'snowflake', remembrance:'feather',
    'pet-remembrance':'paw', birthday:'cake-candles', family:'house-chimney',
    'pet-lovers':'paw', graduation:'graduation-cap', retirement:'leaf',
    'career-thanks':'award', hobbies:'palette', valentines:'heart',
    'mothers-day':'seedling', 'fathers-day':'compass', grandparents:'tree',
    thanksgiving:'wheat-awn', halloween:'ghost'
  };
  var button = document.createElement('button');
  button.type = 'button'; button.className = 'vp-back-top'; button.hidden = true;
  button.setAttribute('data-vp-back-top', ''); button.setAttribute('data-theme', theme);
  button.setAttribute('aria-label', T('js.app.back_to_top', 'Back to top')); button.title = T('js.app.back_to_top', 'Back to top');
  if (occasion) {
    var palette = getComputedStyle(occasion);
    button.style.setProperty('--top-tone', palette.getPropertyValue('--op-primary'));
    button.style.setProperty('--top-accent', palette.getPropertyValue('--op-accent'));
  }
  var arrow = document.createElement('i');
  arrow.className = 'fa-solid fa-arrow-up vp-back-top__arrow'; arrow.setAttribute('aria-hidden', 'true');
  button.appendChild(arrow);
  var floral = occasion && occasion.querySelector('.op-floral-edge');
  if (theme === 'wedding' && floral) {
    var flowers = document.createElement('img');
    flowers.src = floral.currentSrc || floral.src; flowers.alt = '';
    flowers.width = 80; flowers.height = 80; flowers.className = 'vp-back-top__flowers';
    button.appendChild(flowers);
  } else if (motifs[theme]) {
    var motif = document.createElement('i');
    motif.className = 'fa-solid fa-' + motifs[theme] + ' vp-back-top__motif';
    motif.setAttribute('aria-hidden', 'true'); button.appendChild(motif);
  }
  var label = document.createElement('span'); label.className = 'vp-back-top__label';
  label.textContent = T('js.app.back_to_top_label', 'Top'); button.appendChild(label); document.body.appendChild(button);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var queued = false;
  // 10-21 体验优化：手机商品页上，购买表单（选项 / 上传照片 / 加购按钮）落在屏幕下半部分时先不显示，免得压住上传框和按钮；表单滚过去了再出来
  var buyForm = document.getElementById('vpCartForm');
  var phone = window.matchMedia('(max-width: 749px)');
  function overBuyForm() {
    if (!buyForm || !phone.matches) return false;
    var r = buyForm.getBoundingClientRect(), h = window.innerHeight;
    return r.top < h - 20 && r.bottom > h - 260;
  }
  function update() {
    queued = false;
    button.hidden = window.scrollY < 420 || overBuyForm();
  }
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; window.requestAnimationFrame(update); }
  }, {passive:true});
  window.addEventListener('pageshow', update);
  button.addEventListener('click', function () {
    var first = document.querySelector('#nav a, header a, .nav a');
    if (first) first.focus({preventScroll:true});
    window.scrollTo({top:0, behavior:reduced.matches ? 'instant' : 'smooth'});
  });
  update();
}());
/* 10-28 用户批：「立即购买」只买这一件。原来立即购买 = 表单里 name=return_to、value=…/checkout 的提交按钮，先加进购物车再跳结算，
   会把购物车里原有的商品一起带进结账（10-24 查德国结账发现，10-28 又见一次：€90 的单结账变 €176）。
   现在：按下立即购买时先把购物车里原有的商品记到 localStorage、清空购物车，再照常提交（照片照常上传），结账里就只有这一件；
   顾客回到网站任一页时，把记下来的商品原样放回购物车（属性、照片链接都带上），东西不会丢。
   只认提交到 /cart/add、按下的是 return_to=…checkout 的按钮（含底部常驻栏 form="vpCartForm" 的那个）；别的脚本已经拦下的提交（照片还在检查、没选照片的提示）不动；
   浏览器不支持 submitter / requestSubmit、或记不下来（无痕模式存不了）时照旧（不清购物车）。 */
(function () {
  if (!window.fetch || !window.JSON) return;
  var KEY = 'vp-buynow-stash';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function save(v) { try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); return true; } catch (e) { return false; } }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function call(path, body) {
    var o = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return fetch(root + path, o).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function sig(id, props) { return id + '|' + JSON.stringify(props || {}); }
  var passing = null;
  document.addEventListener('submit', function (event) {
    var form = event.target, btn = event.submitter;
    if (passing && passing === form) { passing = null; return; }
    if (event.defaultPrevented || !form || !btn || btn.name !== 'return_to' || !/checkout\/?$/.test(btn.value || '')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '') || typeof form.requestSubmit !== 'function') return;
    event.preventDefault();
    var sent = false;
    function go() { if (sent) return; sent = true; passing = form; form.requestSubmit(btn); }
    call('cart.js').then(function (cart) {
      var items = (cart && cart.items) || [];
      if (!items.length) return go();
      var keep = [], seen = {}, old = load();
      ((old && old.items) || []).concat(items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; }))
        .forEach(function (i) { var k = sig(i.id, i.properties); if (!seen[k]) { seen[k] = 1; keep.push(i); } });
      if (!save({ at: Date.now(), items: keep })) return go();
      return call('cart/clear.js', {}).then(go, go);
    }).catch(go);
  });
  var stash = load();
  if (!stash || !stash.items || !stash.items.length) return;
  if (Date.now() - (stash.at || 0) > 14 * 864e5) { save(null); return; }
  // 10-28 晚：放回失败（断网、Shopify 限流 429 等）不丢暂存，下次打开页面再试，最多 3 次；每次都先对一遍购物车，已经在的不重复加
  function later() { stash.tries = (stash.tries || 0) + 1; save(stash.tries >= 3 ? null : stash); }
  call('cart.js').then(function (cart) {
    var have = {};
    ((cart && cart.items) || []).forEach(function (i) { have[sig(i.variant_id, i.properties)] = 1; });
    var add = stash.items.filter(function (i) { return !have[sig(i.id, i.properties)]; });
    if (!add.length) { save(null); return; }
    return call('cart/add.js', { items: add }).then(function () {
      save(null);
      try { document.dispatchEvent(new CustomEvent('vp:cart-restored', { detail: { count: add.length } })); } catch (e) {}
    }, later);
  }).catch(later);
}());
